var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _rect, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 338,
    viewBox: "0 0 592 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_3)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_112_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 592,
    height: 338.192,
    rx: 19.6243,
    fill: "#FFEDED"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_112_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.234 -0.922171L299.693 6.04195L298.147 5.91987L298.728 -1.04425L300.234 -0.922171Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.147 13.0119L298.606 19.976L296.99 19.8481L297.572 12.884L299.147 13.0119Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.06 26.94L297.519 33.91L295.833 33.7704L296.415 26.8063L298.06 26.94Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.973 40.8741L296.7 44.3503H294.968L294.694 40.8741L296.415 40.7346L296.7 44.2108H294.968L295.252 40.7346L296.973 40.8741Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.147 33.91L293.606 26.94L295.257 26.8063L295.833 33.7704L294.147 33.91Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.06 19.976L292.513 13.0119L294.1 12.884L294.676 19.8481L293.06 19.976Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.974 6.04195L291.433 -0.922171L292.945 -1.04425L293.52 5.91987L291.974 6.04195Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.508 0.298569L286.38 7.03017L284.886 7.4429L283.049 0.699676L284.508 0.298569Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.253 13.7617L290.125 20.4933L288.561 20.9235L286.724 14.1802L288.253 13.7617Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.997 27.225L293.869 33.9566L292.241 34.4042L290.404 27.6668L291.997 27.225Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.741 40.6881L296.671 44.0481L295.044 44.641L293.596 41.4671L295.166 40.7521L296.625 43.9202L294.997 44.5132L294.079 41.1474L295.741 40.6881Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.701 35.1075L287.812 28.7479L289.317 28.062L292.241 34.4041L290.701 35.1075Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.917 22.3885L282.022 16.0289L283.464 15.372L286.394 21.7141L284.917 22.3885Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.127 9.66927L276.238 3.30971L277.616 2.68189L280.54 9.02401L279.127 9.66927Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.005 -4.5321L266.086 1.1357L264.883 1.99604L260.872 -3.72988L262.005 -4.5321Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.151 6.82671L274.215 12.5119L272.947 13.4072L268.919 7.69867L270.151 6.82671Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.272 18.1972L282.335 23.8824L281.016 24.8183L276.981 19.1156L278.272 18.1972Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.392 29.5676L290.456 35.2529L289.078 36.2295L285.044 30.5268L286.392 29.5676Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.513 40.9381L296.542 43.7749L295.21 44.891L292.769 42.403L293.995 41.1939L296.454 43.6702L295.123 44.7864L293.112 41.9379L294.513 40.9381Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.875 37.4154L282.98 32.4335L284.16 31.2651L289.078 36.2295L287.875 37.4154Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.086 27.4458L273.191 22.4581L274.325 21.342L279.243 26.3064L278.086 27.4458Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.297 17.4705L263.408 12.4829L264.483 11.4191L269.401 16.3835L268.297 17.4705Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.514 7.49524L253.637 2.49595L254.631 1.51353L259.566 6.46051L258.514 7.49524Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79 2.13554L241.575 6.0594L240.842 7.11158L235.122 3.10052L235.79 2.13554Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.351 9.9832L253.129 13.9129L252.286 15.1278L246.56 11.1226L247.351 9.9832Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.89 17.8658L264.645 21.8187L263.767 23.0976L258.029 19.1156L258.89 17.8658Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.407 25.7717L276.173 29.7305L275.249 31.0617L269.511 27.0797L270.407 25.7717Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.935 33.6834L287.69 37.6363L286.731 39.0256L280.993 35.0436L281.935 33.6834Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.451 41.5891L296.329 43.5656L295.462 45.0654L292.312 43.5656L293.056 42.0019L296.206 43.4958L295.34 44.9956L292.474 43.0075L293.451 41.5891Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.008 40.5544L279.701 37.5432L280.41 36.0434L286.735 39.0255L286.008 40.5544Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.4 34.532L267.093 31.5149L267.773 30.0849L274.092 33.0612L273.4 34.532Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.792 28.5038L254.485 25.4926L255.136 24.1207L261.455 27.1028L260.792 28.5038Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.183 22.4814L241.887 19.447L242.486 18.1855L248.816 21.1444L248.183 22.4814Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.597 16.4009L229.307 13.3606L229.813 12.291L236.149 15.2383L235.597 16.4009Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.019 10.3146L216.73 7.26852L217.148 6.39655L223.484 9.3438L223.019 10.3146Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.443 4.22245L204.165 1.14731L204.461 0.53112L210.809 3.4493L210.443 4.22245Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.142 12.5643L177.537 13.3897L177.508 13.5002L174.142 12.5643Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.319 15.0464L191.103 16.7264L190.975 17.2147L184.238 15.3661L184.319 15.0464Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.888 18.4064L204.672 20.0806L204.456 20.9061L197.719 19.0575L197.888 18.4064Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.444 21.7897L218.222 23.4988L217.949 24.5335L211.206 22.7198L211.444 21.7897Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.994 25.2136L231.766 26.9226L231.446 28.1608L224.697 26.3471L224.994 25.2136Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.545 28.6317L245.318 30.3523L244.946 31.7824L238.197 29.9745L238.545 28.6317Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.085 32.0964L258.851 33.8403L258.456 35.3401L251.701 33.5613L252.085 32.0964Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.611 35.5842L272.378 37.334L271.971 38.8977L265.216 37.1189L265.611 35.5842Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.144 39.078L285.91 40.8219L285.486 42.4554L278.725 40.6766L279.144 39.078Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.676 42.5658L296.054 43.4378L295.751 45.1468L292.281 44.8155L292.444 43.0948L295.914 43.4145L295.612 45.1236L292.24 44.2342L292.676 42.5658Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.323 44.141L278.37 43.4667L278.527 41.8158L285.486 42.4552L285.323 44.141Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.418 42.7925L264.46 42.1181L264.611 40.537L271.569 41.1764L271.418 42.7925Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.507 41.4439L250.555 40.7696L250.694 39.2582L257.652 39.8976L257.507 41.4439Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.596 40.0951L236.649 39.3918L236.777 38.0082L243.735 38.6186L243.596 40.0951Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.696 38.6826L222.744 37.9734L222.854 36.7992L229.818 37.4037L229.696 38.6826Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.793 37.2641L208.846 36.5549L208.933 35.59L215.897 36.1945L215.793 37.2641Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.892 35.84L194.946 35.1017L195.01 34.4216L201.974 34.9913L201.892 35.84Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 34.3577L181.048 33.6136L181.083 33.2823L188.047 33.852L188 34.3577Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.101 32.8462L170.636 32.4625L174.112 32.7299L174.101 32.8462Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.636 56.0988L174.101 55.7151L174.112 55.8314L170.636 56.0988Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.048 54.9478L188 54.2095L188.047 54.7094L181.083 55.2791L181.048 54.9478Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.946 53.4654L201.892 52.7213L201.974 53.57L195.01 54.1397L194.946 53.4654Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.846 52.0063L215.793 51.2971L215.897 52.3667L208.933 52.9654L208.846 52.0063Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.744 50.588L229.696 49.8788L229.818 51.1577L222.854 51.7622L222.744 50.588Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.649 49.1694L243.602 48.466L243.735 49.9426L236.777 50.5529L236.649 49.1694Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.555 47.7918L257.507 47.1175L257.652 48.6638L250.694 49.3032L250.555 47.7918Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.46 46.449L271.418 45.7747L271.569 47.3849L264.611 48.0243L264.46 46.449Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.37 45.1003L285.323 44.4259L285.486 46.1059L278.527 46.7454L278.37 45.1003Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.281 43.7516L295.751 43.4145L296.054 45.1235L292.676 45.9955L292.24 44.3213L295.612 43.4377L295.914 45.1468L292.444 45.4665L292.281 43.7516Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91 47.7394L279.144 49.4892L278.725 47.8847L285.486 46.1001L285.91 47.7394Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.378 51.2331L265.611 52.9771L265.216 51.4424L271.971 49.6636L272.378 51.2331Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.851 54.721L252.085 56.4649L251.701 55L258.456 53.2212L258.851 54.721Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.319 58.2088L238.546 59.9295L238.192 58.5809L244.946 56.7788L245.319 58.2088Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.772 61.6445L224.994 63.3535L224.697 62.2083L231.446 60.3946L231.772 61.6445Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.222 65.0625L211.444 66.7716L211.206 65.8357L217.949 64.022L218.222 65.0625Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.672 68.4807L197.888 70.1607L197.719 69.498L204.456 67.6553L204.672 68.4807Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.103 71.8349L184.319 73.5149L184.238 73.1952L190.975 71.3466L191.103 71.8349Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.537 75.1716L174.142 75.997L177.508 75.0611L177.537 75.1716Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.228 98.2033L185.355 96.657L185.402 96.7616L182.228 98.2033Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.621 93.5644L197.893 90.4892L198.108 90.9426L191.76 93.8608L191.621 93.5644Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.173 87.4139L210.445 84.3446L210.811 85.1119L204.463 88.0243L204.173 87.4139Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.735 81.2928L223.024 78.2525L223.478 79.2175L217.147 82.1648L216.735 81.2928Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.307 75.2064L235.597 72.1603L236.149 73.3229L229.813 76.2702L229.307 75.2064Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.887 69.1202L248.183 66.0799L248.816 67.4169L242.486 70.37L241.887 69.1202Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.485 63.0686L260.792 60.0574L261.455 61.4583L255.136 64.4347L254.485 63.0686Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.093 57.0462L273.4 54.035L274.092 55.4941L267.773 58.4763L267.093 57.0462Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.701 51.0238L286.008 48.0068L286.729 49.5357L280.41 52.5178L279.701 51.0238Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.312 44.9957L295.462 43.4959L296.329 44.9957L293.457 46.9721L292.474 45.5479L295.34 43.5656L296.206 45.0654L293.056 46.5536L292.312 44.9957Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.696 50.9251L281.935 54.878L280.993 53.5177L286.731 49.5358L287.696 50.9251Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.173 58.8366L270.412 62.7896L269.511 61.4816L275.249 57.4996L276.173 58.8366Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.651 66.7425L258.89 70.6954L258.029 69.4456L263.767 65.4636L264.651 66.7425Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.129 74.6484L247.351 78.5839L246.56 77.4329L252.286 73.4276L253.129 74.6484Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.575 82.5078L235.79 86.4317L235.122 85.455L240.842 81.444L241.575 82.5078Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.011 90.3555L224.227 94.2793L223.681 93.4829L229.401 89.4718L230.011 90.3555Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.449 98.2033L212.647 102.098L212.258 101.54L217.96 97.4999L218.449 98.2033Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.845 105.993L201.044 109.888L200.858 109.614L206.56 105.574L206.845 105.993Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.231 113.771L192.331 115.701L195.167 113.672L195.231 113.771Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.521 133.809L209.933 131.286L210.014 131.367L207.521 133.809Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.763 126.234L219.605 121.2L219.966 121.554L214.996 126.467L214.763 126.234Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.455 116.166L229.297 111.132L229.902 111.724L224.931 116.642L224.455 116.166Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.162 106.115L239.033 101.104L239.795 101.854L234.848 106.795L234.162 106.115Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.899 96.0929L248.771 91.082L249.683 91.983L244.736 96.9184L243.899 96.0929Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.637 86.0711L258.514 81.066L259.566 82.1008L254.625 87.0477L253.637 86.0711Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.408 76.0784L268.297 71.0907L269.401 72.1778L264.483 77.1422L263.408 76.0784Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.197 66.1031L278.085 61.1155L279.242 62.2548L274.324 67.2192L273.197 66.1031Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.98 56.1336L287.875 51.1459L289.078 52.3318L284.16 57.2904L282.98 56.1336Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.769 46.1583L295.21 43.6703L296.542 44.7864L294.519 47.6232L293.106 46.6234L295.123 43.775L296.454 44.8911L293.995 47.3675L292.769 46.1583Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.456 53.3084L286.392 58.9937L285.044 58.0345L289.078 52.3318L290.456 53.3084Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.335 64.6789L278.272 70.37L276.981 69.4457L281.01 63.743L282.335 64.6789Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.215 76.0494L270.152 81.7404L268.914 80.8627L272.948 75.1542L274.215 76.0494Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.092 87.4257L262.005 93.0935L260.872 92.2854L264.883 86.5653L266.092 87.4257Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.921 98.7612L253.828 104.423L252.863 103.737L256.868 98.0113L257.921 98.7612Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.74 110.091L245.648 115.753L244.857 115.195L248.862 109.463L249.74 110.091Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.555 121.415L237.434 127.06L236.882 126.67L240.858 120.921L241.555 121.415Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.318 132.71L229.202 138.354L228.929 138.162L232.905 132.413L233.318 132.71Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.071 143.987L223.002 146.795L224.972 143.917L225.071 143.987Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.468 158.613L244.869 155.416L244.973 155.468L243.468 158.613Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.346 136.244L256.171 129.856L256.944 130.21L253.956 136.529L253.346 136.244Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.031 123.479L261.891 117.107L262.867 117.549L259.908 123.88L259.031 123.479Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.751 110.73L267.617 104.359L268.78 104.888L265.821 111.219L264.751 110.73Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.477 97.9823L273.343 91.6111L274.685 92.2273L271.738 98.5578L270.477 97.9823Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.238 85.2515L279.133 78.892L280.54 79.5372L277.616 85.8793L276.238 85.2515Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.022 72.5325L284.917 66.1729L286.388 66.8473L283.464 73.1894L282.022 72.5325Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.812 59.8133L290.707 53.4538L292.241 54.1571L289.317 60.4993L287.812 59.8133Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.596 47.0942L295.044 43.9203L296.671 44.5132L295.741 47.8732L294.073 47.414L294.997 44.0482L296.625 44.6411L295.166 47.8093L293.596 47.0942Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.869 54.6048L291.997 61.3364L290.399 60.8946L292.236 54.1572L293.869 54.6048Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.125 68.068L288.253 74.7996L286.724 74.3753L288.561 67.6379L290.125 68.068Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 81.5311L284.508 88.2627L283.049 87.8616L284.886 81.1184L286.38 81.5311Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.638 94.9944L280.742 101.72L279.4 101.348L281.213 94.5991L282.638 94.9944Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.837 108.44L276.936 115.166L275.796 114.852L277.598 108.097L278.837 108.44Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.028 121.886L273.121 128.606L272.185 128.35L273.987 121.601L275.028 121.886Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.208 135.332L269.272 142.04L268.615 141.86L270.382 135.105L271.208 135.332Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.331 148.754L265.395 155.468L265.075 155.381L266.843 148.62L267.331 148.754Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.438 162.177L262.455 165.525L263.327 162.148L263.438 162.177Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.731 169.629L285.951 166.147L286.068 166.159L285.731 169.629Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.41 159.171L286.881 152.201L287.386 152.242L286.735 159.2L286.41 159.171Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.357 145.231L287.834 138.261L288.677 138.331L288.032 145.284L287.357 145.231Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.335 131.292L288.847 124.322L289.911 124.409L289.3 131.367L288.335 131.292Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.352 117.352L289.863 110.387L291.142 110.486L290.526 117.45L289.352 117.352Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.368 103.418L290.886 96.4476L292.362 96.5696L291.752 103.528L290.368 103.418Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.433 89.4834L291.974 82.5193L293.52 82.6414L292.939 89.6055L291.433 89.4834Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.521 75.5494L293.062 68.5853L294.678 68.7132L294.096 75.6773L292.521 75.5494Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.606 61.6213L294.147 54.6513L295.833 54.7908L295.252 61.755L293.606 61.6213Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.694 47.6872L294.968 44.2109H296.7L296.973 47.6872L295.252 47.8267L294.968 44.3504H296.7L296.415 47.8267L294.694 47.6872Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.519 54.6513L298.06 61.6213L296.409 61.755L295.833 54.7908L297.519 54.6513Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.606 68.5853L299.153 75.5494L297.566 75.6773L296.99 68.7132L298.606 68.5853Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.693 82.5193L300.234 89.4834L298.723 89.6055L298.147 82.6414L299.693 82.5193Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.78 96.4476L301.298 103.418L299.909 103.528L299.304 96.5696L300.78 96.4476Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.809 110.382L302.315 117.352L301.135 117.45L300.525 110.486L301.809 110.382Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.82 124.322L303.332 131.292L302.367 131.367L301.75 124.409L302.82 124.322Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.838 138.261L304.309 145.231L303.635 145.284L302.984 138.331L303.838 138.261Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.784 152.201L305.255 159.171L304.93 159.2L304.279 152.242L304.784 152.201Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.715 166.147L305.936 169.629L305.599 166.159L305.715 166.147Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.213 165.525L328.231 162.177L328.341 162.148L329.213 165.525Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.272 155.468L324.336 148.754L324.819 148.62L326.592 155.381L326.272 155.468Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.393 142.04L320.457 135.332L321.277 135.105L323.05 141.86L322.393 142.04Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.551 128.606L316.644 121.886L317.673 121.601L319.481 128.35L318.551 128.606Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.738 115.166L312.831 108.44L314.07 108.103L315.872 114.852L314.738 115.166Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.924 101.72L309.029 94.9944L310.453 94.5991L312.267 101.348L310.924 101.72Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.157 88.2627L305.285 81.5311L306.779 81.1184L308.616 87.8616L307.157 88.2627Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.413 74.7996L301.541 68.068L303.105 67.6379L304.942 74.3811L303.413 74.7996Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.669 61.3364L297.797 54.6048L299.425 54.1572L301.268 60.8946L299.669 61.3364Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.926 47.8732L294.996 44.5132L296.623 43.9203L298.071 47.0942L296.501 47.8093L295.042 44.6411L296.67 44.0482L297.588 47.414L295.926 47.8732Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.967 53.4538L303.856 59.8133L302.351 60.4993L299.427 54.1571L300.967 53.4538Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.751 66.1729L309.646 72.5325L308.205 73.1894L305.275 66.8473L306.751 66.1729Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.541 78.892L315.43 85.2515L314.052 85.8793L311.128 79.5372L312.541 78.892Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.325 91.6111L321.197 97.9823L319.929 98.5636L316.976 92.2273L318.325 91.6111Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.057 104.353L326.917 110.73L325.841 111.219L322.888 104.894L324.057 104.353Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.777 117.102L332.637 123.479L331.759 123.88L328.8 117.555L329.777 117.102Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.496 129.856L338.327 136.244L337.705 136.529L334.717 130.21L335.496 129.856Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.158 142.633L343.983 149.022L343.686 149.161L340.698 142.842L341.158 142.633Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.797 155.416L348.198 158.613L346.692 155.468L346.797 155.416Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.666 146.795L366.596 143.987L366.695 143.917L368.666 146.795Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.463 138.354L358.348 132.704L358.76 132.413L362.737 138.162L362.463 138.354Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.233 127.06L350.117 121.415L350.809 120.921L354.785 126.67L354.233 127.06Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.019 115.753L341.932 110.085L342.804 109.469L346.809 115.195L346.019 115.753Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.839 104.423L333.752 98.7554L334.793 98.0172L338.798 103.743L337.839 104.423Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.661 93.0935L325.58 87.4199L326.783 86.5653L330.794 92.2854L329.661 93.0935Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.515 81.7346L317.451 76.0494L318.718 75.1542L322.747 80.8627L321.515 81.7346Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.394 70.3641L309.33 64.6789L310.65 63.743L314.684 69.4515L313.394 70.3641Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.275 58.9937L301.212 53.3084L302.589 52.3318L306.624 58.0345L305.275 58.9937Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.152 47.6232L295.123 44.7864L296.455 43.6703L298.896 46.1583L297.67 47.3733L295.211 44.8911L296.542 43.775L298.553 46.6234L297.152 47.6232Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.791 51.1459L308.686 56.1278L307.506 57.2962L302.588 52.3318L303.791 51.1459Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.58 61.1155L318.474 66.1031L317.341 67.2192L312.423 62.2548L313.58 61.1155Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.37 71.0907L328.264 76.0784L327.183 77.1422L322.265 72.1778L323.37 71.0907Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.155 81.0603L338.032 86.0654L337.038 87.0478L332.102 82.1008L333.155 81.0603Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.901 91.082L347.767 96.0929L346.924 96.9184L341.983 91.983L342.901 91.082Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.639 101.104L357.504 106.115L356.818 106.795L351.871 101.86L352.639 101.104Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.369 111.132L367.217 116.166L366.729 116.642L361.765 111.73L362.369 111.132Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.062 121.2L376.904 126.234L376.672 126.467L371.702 121.554L372.062 121.2Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.735 131.286L384.147 133.809L381.654 131.367L381.735 131.286Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.336 115.701L396.435 113.771L396.499 113.672L399.336 115.701Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.622 109.888L384.82 105.993L385.105 105.58L390.808 109.62L390.622 109.888Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.019 102.098L373.224 98.1974L373.706 97.4999L379.403 101.54L379.019 102.098Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.439 94.2793L361.655 90.3555L362.265 89.4718L367.985 93.4829L367.439 94.2793Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.877 86.4258L350.099 82.5019L350.826 81.4498L356.546 85.4608L355.877 86.4258Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.314 78.578L338.535 74.6484L339.378 73.4276L345.104 77.4387L344.314 78.578Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.776 70.6954L327.015 66.7425L327.899 65.4636L333.636 69.4456L332.776 70.6954Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.259 62.7837L315.492 58.8308L316.417 57.4996L322.154 61.4816L321.259 62.7837Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.738 54.878L303.977 50.9251L304.937 49.5358L310.674 53.5177L309.738 54.878Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.218 46.9721L295.34 44.9957L296.207 43.4959L299.357 44.9957L298.613 46.5594L295.463 45.0654L296.329 43.5656L299.195 45.5537L298.218 46.9721Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.657 48.0068L311.964 51.018L311.249 52.5178L304.93 49.5357L305.657 48.0068Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.266 54.0293L324.573 57.0463L323.893 58.4764L317.574 55.5L318.266 54.0293Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 60.0574L337.182 63.0686L336.531 64.4405L330.213 61.4583L330.875 60.0574Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.482 66.0799L349.778 69.1143L349.179 70.3758L342.849 67.4169L343.482 66.0799Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.068 72.1603L362.358 75.2006L361.852 76.2702L355.516 73.3229L356.068 72.1603Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.647 78.2466L374.931 81.2927L374.519 82.1647L368.182 79.2174L368.647 78.2466Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.223 84.3389L387.501 87.414L387.205 88.0302L380.857 85.112L381.223 84.3389Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.772 90.4892L400.044 93.5644L399.905 93.8666L393.557 90.9485L393.772 90.4892Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.312 96.657L409.439 98.2033L406.259 96.7616L406.312 96.657Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.519 75.997L414.13 75.1716L414.159 75.0611L417.519 75.997Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.346 73.5149L400.562 71.8349L400.69 71.3466L407.427 73.1952L407.346 73.5149Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.778 70.1549L386.994 68.4807L387.209 67.6553L393.946 69.5038L393.778 70.1549Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.221 66.7717L373.443 65.0626L373.716 64.0279L380.46 65.8358L380.221 66.7717Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.671 63.3535L359.893 61.6386L360.218 60.4004L366.967 62.2141L366.671 63.3535Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.122 59.9295L346.35 58.2088L346.722 56.7788L353.471 58.5867L353.122 59.9295Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.584 56.4649L332.817 54.721L333.213 53.2212L339.968 55L339.584 56.4649Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.056 52.9771L319.29 51.2331L319.697 49.6636L326.452 51.4424L326.056 52.9771Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.524 49.4834L305.757 47.7395L306.182 46.106L312.942 47.8848L312.524 49.4834Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.991 45.9955L295.614 45.1235L295.916 43.4145L299.386 43.7458L299.224 45.4665L295.753 45.1468L296.056 43.4377L299.427 44.3271L298.991 45.9955Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.344 44.4202L313.297 45.0945L313.14 46.7454L306.181 46.106L306.344 44.4202Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.248 45.7689L327.206 46.4432L327.055 48.0244L320.097 47.385L320.248 45.7689Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.16 47.1175L341.113 47.7918L340.973 49.3032L334.015 48.6638L334.16 47.1175Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.07 48.466L355.017 49.1694L354.889 50.5529L347.931 49.9426L348.07 48.466Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.968 49.8788L368.921 50.588L368.811 51.7622L361.846 51.1577L361.968 49.8788Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.874 51.2971L382.821 52.0063L382.734 52.9712L375.77 52.3667L375.874 51.2971Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.774 52.7213L396.721 53.4596L396.657 54.1397L389.693 53.57L389.774 52.7213Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.668 54.2036L410.62 54.9477L410.586 55.279L403.621 54.7093L403.668 54.2036Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.567 55.7151L421.031 56.0988L417.555 55.8314L417.567 55.7151Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.031 32.4625L417.567 32.8462L417.555 32.7299L421.031 32.4625Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.62 33.6136L403.668 34.3519L403.621 33.852L410.586 33.2823L410.62 33.6136Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.721 35.0959L389.774 35.84L389.693 34.9971L396.657 34.4216L396.721 35.0959Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.821 36.555L375.874 37.2642L375.77 36.1946L382.734 35.5959L382.821 36.555Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.921 37.9734L361.968 38.6826L361.846 37.4037L368.811 36.7992L368.921 37.9734Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.017 39.3918L348.07 40.0951L347.931 38.6186L354.889 38.0082L355.017 39.3918Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.113 40.7696L334.16 41.4439L334.015 39.8976L340.973 39.2582L341.113 40.7696Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.206 42.1181L320.248 42.7866L320.097 41.1764L327.055 40.537L327.206 42.1181Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.297 43.4609L306.344 44.1352L306.181 42.4552L313.14 41.8158L313.297 43.4609Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.386 44.8097L295.916 45.1468L295.614 43.4378L298.991 42.5658L299.427 44.24L296.056 45.1236L295.753 43.4145L299.224 43.0948L299.386 44.8097Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.757 40.8218L312.524 39.0721L312.942 40.6765L306.182 42.4611L305.757 40.8218Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.29 37.3281L326.056 35.5842L326.452 37.1189L319.697 38.8977L319.29 37.3281Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.817 33.8403L339.584 32.0964L339.968 33.5613L333.213 35.3401L332.817 33.8403Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.35 30.3465L353.122 28.6317L353.471 29.9803L346.722 31.7824L346.35 30.3465Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.893 26.9169L366.671 25.2078L366.967 26.353L360.218 28.1667L359.893 26.9169Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.443 23.4988L380.221 21.7897L380.46 22.7256L373.716 24.5393L373.443 23.4988Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.994 20.0807L393.778 18.4007L393.946 19.0634L387.209 20.9061L386.994 20.0807Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.562 16.7264L407.346 15.0464L407.427 15.3661L400.69 17.2147L400.562 16.7264Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.13 13.3897L417.519 12.5643L414.159 13.5002L414.13 13.3897Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.495 1.14725L381.223 4.22238L380.857 3.44924L387.205 0.536865L387.495 1.14725Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.931 7.26852L368.642 10.3088L368.182 9.3438L374.519 6.39655L374.931 7.26852Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.358 13.3548L356.068 16.4009L355.516 15.2383L361.852 12.291L362.358 13.3548Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.778 19.4411L343.482 22.4813L342.849 21.1443L349.179 18.1913L349.778 19.4411Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.182 25.4927L330.875 28.5039L330.213 27.1029L336.531 24.1266L337.182 25.4927Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.573 31.5149L318.266 34.5261L317.574 33.0671L323.893 30.0849L324.573 31.5149Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.964 37.5432L305.657 40.5544L304.93 39.0255L311.255 36.0434L311.964 37.5432Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.357 43.5656L296.207 45.0654L295.34 43.5656L298.212 41.5891L299.195 43.0134L296.329 44.9956L295.463 43.4958L298.613 42.0077L299.357 43.5656Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.972 37.6363L309.733 33.6834L310.675 35.0436L304.937 39.0315L303.972 37.6363Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.492 29.7305L321.253 25.7717L322.154 27.0797L316.417 31.0617L315.492 29.7305Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.015 21.8187L332.776 17.8658L333.642 19.1156L327.899 23.0976L327.015 21.8187Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.535 13.9129L344.314 9.97746L345.104 11.1285L339.378 15.1337L338.535 13.9129Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.094 6.0535L355.878 2.12964L356.546 3.10043L350.826 7.1173L350.094 6.0535Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.032 2.49007L333.155 7.49517L332.102 6.46043L337.044 1.51928L338.032 2.49007Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.258 12.4829L323.37 17.4705L322.265 16.3835L327.183 11.4191L328.258 12.4829Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.468 22.4581L313.58 27.4458L312.423 26.3064L317.341 21.342L318.468 22.4581Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.686 32.4277L303.791 37.4153L302.588 36.2294L307.506 31.2708L308.686 32.4277Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.896 42.403L296.455 44.891L295.123 43.7749L297.146 40.9381L298.559 41.9379L296.542 44.7864L295.211 43.6702L297.67 41.1939L298.896 42.403Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.212 35.2529L305.275 29.5676L306.624 30.5268L302.589 36.2295L301.212 35.2529Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.33 23.8824L313.394 18.1972L314.684 19.1156L310.656 24.8183L309.33 23.8824Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.451 12.506L321.515 6.8208L322.753 7.7044L318.718 13.4071L317.451 12.506Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.58 1.1357L329.661 -4.5321L330.794 -3.72407L326.783 1.99604L325.58 1.1357Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.43 3.30971L312.535 9.66927L311.128 9.02401L314.052 2.68189L315.43 3.30971Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.646 16.0289L306.751 22.3885L305.28 21.7141L308.204 15.372L309.646 16.0289Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.856 28.7479L300.961 35.1075L299.427 34.4041L302.351 28.062L303.856 28.7479Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.071 41.4671L296.623 44.641L294.996 44.0481L295.926 40.6881L297.594 41.1474L296.67 44.5132L295.042 43.9202L296.501 40.7521L298.071 41.4671Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.797 33.9566L299.669 27.225L301.268 27.6668L299.431 34.4042L297.797 33.9566Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.541 20.4933L303.413 13.7617L304.942 14.1802L303.105 20.9235L301.541 20.4933Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.285 7.03017L307.157 0.298569L308.616 0.699676L306.779 7.4429L305.285 7.03017Z",
    fill: "#1C3E76",
    fillOpacity: 0.75
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.234 -0.922171L299.693 6.04195L298.147 5.91987L298.728 -1.04425L300.234 -0.922171Z",
    fill: "#1C3E76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.147 13.0119L298.606 19.976L296.99 19.8481L297.572 12.884L299.147 13.0119Z",
    fill: "#1C3E76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M298.06 26.94L297.519 33.91L295.833 33.7704L296.415 26.8063L298.06 26.94Z",
    fill: "#1C3E76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M296.973 40.8741L296.7 44.3503H294.968L294.694 40.8741L296.415 40.7346L296.7 44.2108H294.968L295.252 40.7346L296.973 40.8741Z",
    fill: "#1C3E76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.147 33.91L293.606 26.94L295.257 26.8063L295.833 33.7704L294.147 33.91Z",
    fill: "#1C3E76"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.06 19.976L292.513 13.0119L294.1 12.884L294.676 19.8481L293.06 19.976Z",
    fill: "#1C3E76"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M291.974 6.04195L291.433 -0.922171L292.945 -1.04425L293.52 5.91987L291.974 6.04195Z",
    fill: "#1C3E76"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M284.508 0.298569L286.38 7.03017L284.886 7.4429L283.049 0.699676L284.508 0.298569Z",
    fill: "#1C3E76"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M288.253 13.7617L290.125 20.4933L288.561 20.9235L286.724 14.1802L288.253 13.7617Z",
    fill: "#1C3E76"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M291.997 27.225L293.869 33.9566L292.241 34.4042L290.404 27.6668L291.997 27.225Z",
    fill: "#1C3E76"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M295.741 40.6881L296.671 44.0481L295.044 44.641L293.596 41.4671L295.166 40.7521L296.625 43.9202L294.997 44.5132L294.079 41.1474L295.741 40.6881Z",
    fill: "#1C3E76"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M290.701 35.1075L287.812 28.7479L289.317 28.062L292.241 34.4041L290.701 35.1075Z",
    fill: "#1C3E76"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M284.917 22.3885L282.022 16.0289L283.464 15.372L286.394 21.7141L284.917 22.3885Z",
    fill: "#1C3E76"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M279.127 9.66927L276.238 3.30971L277.616 2.68189L280.54 9.02401L279.127 9.66927Z",
    fill: "#1C3E76"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M262.005 -4.5321L266.086 1.1357L264.883 1.99604L260.872 -3.72988L262.005 -4.5321Z",
    fill: "#1C3E76"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M270.151 6.82671L274.215 12.5119L272.947 13.4072L268.919 7.69867L270.151 6.82671Z",
    fill: "#1C3E76"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M278.272 18.1972L282.335 23.8824L281.016 24.8183L276.981 19.1156L278.272 18.1972Z",
    fill: "#1C3E76"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M286.392 29.5676L290.456 35.2529L289.078 36.2295L285.044 30.5268L286.392 29.5676Z",
    fill: "#1C3E76"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M294.513 40.9381L296.542 43.7749L295.21 44.891L292.769 42.403L293.995 41.1939L296.454 43.6702L295.123 44.7864L293.112 41.9379L294.513 40.9381Z",
    fill: "#1C3E76"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M287.875 37.4154L282.98 32.4335L284.16 31.2651L289.078 36.2295L287.875 37.4154Z",
    fill: "#1C3E76"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M278.086 27.4458L273.191 22.4581L274.325 21.342L279.243 26.3064L278.086 27.4458Z",
    fill: "#1C3E76"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M268.297 17.4705L263.408 12.4829L264.483 11.4191L269.401 16.3835L268.297 17.4705Z",
    fill: "#1C3E76"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M258.514 7.49524L253.637 2.49595L254.631 1.51353L259.566 6.46051L258.514 7.49524Z",
    fill: "#1C3E76"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M235.79 2.13554L241.575 6.0594L240.842 7.11158L235.122 3.10052L235.79 2.13554Z",
    fill: "#1C3E76"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M247.351 9.9832L253.129 13.9129L252.286 15.1278L246.56 11.1226L247.351 9.9832Z",
    fill: "#1C3E76"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M258.89 17.8658L264.645 21.8187L263.767 23.0976L258.029 19.1156L258.89 17.8658Z",
    fill: "#1C3E76"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M270.407 25.7717L276.173 29.7305L275.249 31.0617L269.511 27.0797L270.407 25.7717Z",
    fill: "#1C3E76"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M281.935 33.6834L287.69 37.6363L286.731 39.0256L280.993 35.0436L281.935 33.6834Z",
    fill: "#1C3E76"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M293.451 41.5891L296.329 43.5656L295.462 45.0654L292.312 43.5656L293.056 42.0019L296.206 43.4958L295.34 44.9956L292.474 43.0075L293.451 41.5891Z",
    fill: "#1C3E76"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M286.008 40.5544L279.701 37.5432L280.41 36.0434L286.735 39.0255L286.008 40.5544Z",
    fill: "#1C3E76"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M273.4 34.532L267.093 31.5149L267.773 30.0849L274.092 33.0612L273.4 34.532Z",
    fill: "#1C3E76"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M260.792 28.5038L254.485 25.4926L255.136 24.1207L261.455 27.1028L260.792 28.5038Z",
    fill: "#1C3E76"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M248.183 22.4814L241.887 19.447L242.486 18.1855L248.816 21.1444L248.183 22.4814Z",
    fill: "#1C3E76"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M235.597 16.4009L229.307 13.3606L229.813 12.291L236.149 15.2383L235.597 16.4009Z",
    fill: "#1C3E76"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M223.019 10.3146L216.73 7.26852L217.148 6.39655L223.484 9.3438L223.019 10.3146Z",
    fill: "#1C3E76"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M210.443 4.22245L204.165 1.14731L204.461 0.53112L210.809 3.4493L210.443 4.22245Z",
    fill: "#1C3E76"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M174.142 12.5643L177.537 13.3897L177.508 13.5002L174.142 12.5643Z",
    fill: "#1C3E76"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M184.319 15.0464L191.103 16.7264L190.975 17.2147L184.238 15.3661L184.319 15.0464Z",
    fill: "#1C3E76"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M197.888 18.4064L204.672 20.0806L204.456 20.9061L197.719 19.0575L197.888 18.4064Z",
    fill: "#1C3E76"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M211.444 21.7897L218.222 23.4988L217.949 24.5335L211.206 22.7198L211.444 21.7897Z",
    fill: "#1C3E76"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M224.994 25.2136L231.766 26.9226L231.446 28.1608L224.697 26.3471L224.994 25.2136Z",
    fill: "#1C3E76"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M238.545 28.6317L245.318 30.3523L244.946 31.7824L238.197 29.9745L238.545 28.6317Z",
    fill: "#1C3E76"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M252.085 32.0964L258.851 33.8403L258.456 35.3401L251.701 33.5613L252.085 32.0964Z",
    fill: "#1C3E76"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M265.611 35.5842L272.378 37.334L271.971 38.8977L265.216 37.1189L265.611 35.5842Z",
    fill: "#1C3E76"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M279.144 39.078L285.91 40.8219L285.486 42.4554L278.725 40.6766L279.144 39.078Z",
    fill: "#1C3E76"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M292.676 42.5658L296.054 43.4378L295.751 45.1468L292.281 44.8155L292.444 43.0948L295.914 43.4145L295.612 45.1236L292.24 44.2342L292.676 42.5658Z",
    fill: "#1C3E76"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M285.323 44.141L278.37 43.4667L278.527 41.8158L285.486 42.4552L285.323 44.141Z",
    fill: "#1C3E76"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M271.418 42.7925L264.46 42.1181L264.611 40.537L271.569 41.1764L271.418 42.7925Z",
    fill: "#1C3E76"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M257.507 41.4439L250.555 40.7696L250.694 39.2582L257.652 39.8976L257.507 41.4439Z",
    fill: "#1C3E76"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M243.596 40.0951L236.649 39.3918L236.777 38.0082L243.735 38.6186L243.596 40.0951Z",
    fill: "#1C3E76"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M229.696 38.6826L222.744 37.9734L222.854 36.7992L229.818 37.4037L229.696 38.6826Z",
    fill: "#1C3E76"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M215.793 37.2641L208.846 36.5549L208.933 35.59L215.897 36.1945L215.793 37.2641Z",
    fill: "#1C3E76"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M201.892 35.84L194.946 35.1017L195.01 34.4216L201.974 34.9913L201.892 35.84Z",
    fill: "#1C3E76"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M188 34.3577L181.048 33.6136L181.083 33.2823L188.047 33.852L188 34.3577Z",
    fill: "#1C3E76"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M174.101 32.8462L170.636 32.4625L174.112 32.7299L174.101 32.8462Z",
    fill: "#1C3E76"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M170.636 56.0988L174.101 55.7151L174.112 55.8314L170.636 56.0988Z",
    fill: "#1C3E76"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M181.048 54.9478L188 54.2095L188.047 54.7094L181.083 55.2791L181.048 54.9478Z",
    fill: "#1C3E76"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M194.946 53.4654L201.892 52.7213L201.974 53.57L195.01 54.1397L194.946 53.4654Z",
    fill: "#1C3E76"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M208.846 52.0063L215.793 51.2971L215.897 52.3667L208.933 52.9654L208.846 52.0063Z",
    fill: "#1C3E76"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M222.744 50.588L229.696 49.8788L229.818 51.1577L222.854 51.7622L222.744 50.588Z",
    fill: "#1C3E76"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M236.649 49.1694L243.602 48.466L243.735 49.9426L236.777 50.5529L236.649 49.1694Z",
    fill: "#1C3E76"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M250.555 47.7918L257.507 47.1175L257.652 48.6638L250.694 49.3032L250.555 47.7918Z",
    fill: "#1C3E76"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M264.46 46.449L271.418 45.7747L271.569 47.3849L264.611 48.0243L264.46 46.449Z",
    fill: "#1C3E76"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M278.37 45.1003L285.323 44.4259L285.486 46.1059L278.527 46.7454L278.37 45.1003Z",
    fill: "#1C3E76"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M292.281 43.7516L295.751 43.4145L296.054 45.1235L292.676 45.9955L292.24 44.3213L295.612 43.4377L295.914 45.1468L292.444 45.4665L292.281 43.7516Z",
    fill: "#1C3E76"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M285.91 47.7394L279.144 49.4892L278.725 47.8847L285.486 46.1001L285.91 47.7394Z",
    fill: "#1C3E76"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M272.378 51.2331L265.611 52.9771L265.216 51.4424L271.971 49.6636L272.378 51.2331Z",
    fill: "#1C3E76"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M258.851 54.721L252.085 56.4649L251.701 55L258.456 53.2212L258.851 54.721Z",
    fill: "#1C3E76"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M245.319 58.2088L238.546 59.9295L238.192 58.5809L244.946 56.7788L245.319 58.2088Z",
    fill: "#1C3E76"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M231.772 61.6445L224.994 63.3535L224.697 62.2083L231.446 60.3946L231.772 61.6445Z",
    fill: "#1C3E76"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M218.222 65.0625L211.444 66.7716L211.206 65.8357L217.949 64.022L218.222 65.0625Z",
    fill: "#1C3E76"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M204.672 68.4807L197.888 70.1607L197.719 69.498L204.456 67.6553L204.672 68.4807Z",
    fill: "#1C3E76"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M191.103 71.8349L184.319 73.5149L184.238 73.1952L190.975 71.3466L191.103 71.8349Z",
    fill: "#1C3E76"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M177.537 75.1716L174.142 75.997L177.508 75.0611L177.537 75.1716Z",
    fill: "#1C3E76"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M182.228 98.2033L185.355 96.657L185.402 96.7616L182.228 98.2033Z",
    fill: "#1C3E76"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M191.621 93.5644L197.893 90.4892L198.108 90.9426L191.76 93.8608L191.621 93.5644Z",
    fill: "#1C3E76"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M204.173 87.4139L210.445 84.3446L210.811 85.1119L204.463 88.0243L204.173 87.4139Z",
    fill: "#1C3E76"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M216.735 81.2928L223.024 78.2525L223.478 79.2175L217.147 82.1648L216.735 81.2928Z",
    fill: "#1C3E76"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M229.307 75.2064L235.597 72.1603L236.149 73.3229L229.813 76.2702L229.307 75.2064Z",
    fill: "#1C3E76"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M241.887 69.1202L248.183 66.0799L248.816 67.4169L242.486 70.37L241.887 69.1202Z",
    fill: "#1C3E76"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M254.485 63.0686L260.792 60.0574L261.455 61.4583L255.136 64.4347L254.485 63.0686Z",
    fill: "#1C3E76"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M267.093 57.0462L273.4 54.035L274.092 55.4941L267.773 58.4763L267.093 57.0462Z",
    fill: "#1C3E76"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M279.701 51.0238L286.008 48.0068L286.729 49.5357L280.41 52.5178L279.701 51.0238Z",
    fill: "#1C3E76"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M292.312 44.9957L295.462 43.4959L296.329 44.9957L293.457 46.9721L292.474 45.5479L295.34 43.5656L296.206 45.0654L293.056 46.5536L292.312 44.9957Z",
    fill: "#1C3E76"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M287.696 50.9251L281.935 54.878L280.993 53.5177L286.731 49.5358L287.696 50.9251Z",
    fill: "#1C3E76"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M276.173 58.8366L270.412 62.7896L269.511 61.4816L275.249 57.4996L276.173 58.8366Z",
    fill: "#1C3E76"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M264.651 66.7425L258.89 70.6954L258.029 69.4456L263.767 65.4636L264.651 66.7425Z",
    fill: "#1C3E76"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M253.129 74.6484L247.351 78.5839L246.56 77.4329L252.286 73.4276L253.129 74.6484Z",
    fill: "#1C3E76"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M241.575 82.5078L235.79 86.4317L235.122 85.455L240.842 81.444L241.575 82.5078Z",
    fill: "#1C3E76"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M230.011 90.3555L224.227 94.2793L223.681 93.4829L229.401 89.4718L230.011 90.3555Z",
    fill: "#1C3E76"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M218.449 98.2033L212.647 102.098L212.258 101.54L217.96 97.4999L218.449 98.2033Z",
    fill: "#1C3E76"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M206.845 105.993L201.044 109.888L200.858 109.614L206.56 105.574L206.845 105.993Z",
    fill: "#1C3E76"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M195.231 113.771L192.331 115.701L195.167 113.672L195.231 113.771Z",
    fill: "#1C3E76"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M207.521 133.809L209.933 131.286L210.014 131.367L207.521 133.809Z",
    fill: "#1C3E76"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M214.763 126.234L219.605 121.2L219.966 121.554L214.996 126.467L214.763 126.234Z",
    fill: "#1C3E76"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M224.455 116.166L229.297 111.132L229.902 111.724L224.931 116.642L224.455 116.166Z",
    fill: "#1C3E76"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M234.162 106.115L239.033 101.104L239.795 101.854L234.848 106.795L234.162 106.115Z",
    fill: "#1C3E76"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M243.899 96.0929L248.771 91.082L249.683 91.983L244.736 96.9184L243.899 96.0929Z",
    fill: "#1C3E76"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M253.637 86.0711L258.514 81.066L259.566 82.1008L254.625 87.0477L253.637 86.0711Z",
    fill: "#1C3E76"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M263.408 76.0784L268.297 71.0907L269.401 72.1778L264.483 77.1422L263.408 76.0784Z",
    fill: "#1C3E76"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M273.197 66.1031L278.085 61.1155L279.242 62.2548L274.324 67.2192L273.197 66.1031Z",
    fill: "#1C3E76"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M282.98 56.1336L287.875 51.1459L289.078 52.3318L284.16 57.2904L282.98 56.1336Z",
    fill: "#1C3E76"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M292.769 46.1583L295.21 43.6703L296.542 44.7864L294.519 47.6232L293.106 46.6234L295.123 43.775L296.454 44.8911L293.995 47.3675L292.769 46.1583Z",
    fill: "#1C3E76"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M290.456 53.3084L286.392 58.9937L285.044 58.0345L289.078 52.3318L290.456 53.3084Z",
    fill: "#1C3E76"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M282.335 64.6789L278.272 70.37L276.981 69.4457L281.01 63.743L282.335 64.6789Z",
    fill: "#1C3E76"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M274.215 76.0494L270.152 81.7404L268.914 80.8627L272.948 75.1542L274.215 76.0494Z",
    fill: "#1C3E76"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M266.092 87.4257L262.005 93.0935L260.872 92.2854L264.883 86.5653L266.092 87.4257Z",
    fill: "#1C3E76"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M257.921 98.7612L253.828 104.423L252.863 103.737L256.868 98.0113L257.921 98.7612Z",
    fill: "#1C3E76"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M249.74 110.091L245.648 115.753L244.857 115.195L248.862 109.463L249.74 110.091Z",
    fill: "#1C3E76"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M241.555 121.415L237.434 127.06L236.882 126.67L240.858 120.921L241.555 121.415Z",
    fill: "#1C3E76"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M233.318 132.71L229.202 138.354L228.929 138.162L232.905 132.413L233.318 132.71Z",
    fill: "#1C3E76"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M225.071 143.987L223.002 146.795L224.972 143.917L225.071 143.987Z",
    fill: "#1C3E76"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M243.468 158.613L244.869 155.416L244.973 155.468L243.468 158.613Z",
    fill: "#1C3E76"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M253.346 136.244L256.171 129.856L256.944 130.21L253.956 136.529L253.346 136.244Z",
    fill: "#1C3E76"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M259.031 123.479L261.891 117.107L262.867 117.549L259.908 123.88L259.031 123.479Z",
    fill: "#1C3E76"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M264.751 110.73L267.617 104.359L268.78 104.888L265.821 111.219L264.751 110.73Z",
    fill: "#1C3E76"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M270.477 97.9823L273.343 91.6111L274.685 92.2273L271.738 98.5578L270.477 97.9823Z",
    fill: "#1C3E76"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M276.238 85.2515L279.133 78.892L280.54 79.5372L277.616 85.8793L276.238 85.2515Z",
    fill: "#1C3E76"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M282.022 72.5325L284.917 66.1729L286.388 66.8473L283.464 73.1894L282.022 72.5325Z",
    fill: "#1C3E76"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M287.812 59.8133L290.707 53.4538L292.241 54.1571L289.317 60.4993L287.812 59.8133Z",
    fill: "#1C3E76"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M293.596 47.0942L295.044 43.9203L296.671 44.5132L295.741 47.8732L294.073 47.414L294.997 44.0482L296.625 44.6411L295.166 47.8093L293.596 47.0942Z",
    fill: "#1C3E76"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M293.869 54.6048L291.997 61.3364L290.399 60.8946L292.236 54.1572L293.869 54.6048Z",
    fill: "#1C3E76"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M290.125 68.068L288.253 74.7996L286.724 74.3753L288.561 67.6379L290.125 68.068Z",
    fill: "#1C3E76"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M286.38 81.5311L284.508 88.2627L283.049 87.8616L284.886 81.1184L286.38 81.5311Z",
    fill: "#1C3E76"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M282.638 94.9944L280.742 101.72L279.4 101.348L281.213 94.5991L282.638 94.9944Z",
    fill: "#1C3E76"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M278.837 108.44L276.936 115.166L275.796 114.852L277.598 108.097L278.837 108.44Z",
    fill: "#1C3E76"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M275.028 121.886L273.121 128.606L272.185 128.35L273.987 121.601L275.028 121.886Z",
    fill: "#1C3E76"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M271.208 135.332L269.272 142.04L268.615 141.86L270.382 135.105L271.208 135.332Z",
    fill: "#1C3E76"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M267.331 148.754L265.395 155.468L265.075 155.381L266.843 148.62L267.331 148.754Z",
    fill: "#1C3E76"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M263.438 162.177L262.455 165.525L263.327 162.148L263.438 162.177Z",
    fill: "#1C3E76"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M285.731 169.629L285.951 166.147L286.068 166.159L285.731 169.629Z",
    fill: "#1C3E76"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M286.41 159.171L286.881 152.201L287.386 152.242L286.735 159.2L286.41 159.171Z",
    fill: "#1C3E76"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M287.357 145.231L287.834 138.261L288.677 138.331L288.032 145.284L287.357 145.231Z",
    fill: "#1C3E76"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M288.335 131.292L288.847 124.322L289.911 124.409L289.3 131.367L288.335 131.292Z",
    fill: "#1C3E76"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M289.352 117.352L289.863 110.387L291.142 110.486L290.526 117.45L289.352 117.352Z",
    fill: "#1C3E76"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M290.368 103.418L290.886 96.4476L292.362 96.5696L291.752 103.528L290.368 103.418Z",
    fill: "#1C3E76"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M291.433 89.4834L291.974 82.5193L293.52 82.6414L292.939 89.6055L291.433 89.4834Z",
    fill: "#1C3E76"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M292.521 75.5494L293.062 68.5853L294.678 68.7132L294.096 75.6773L292.521 75.5494Z",
    fill: "#1C3E76"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M293.606 61.6213L294.147 54.6513L295.833 54.7908L295.252 61.755L293.606 61.6213Z",
    fill: "#1C3E76"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M294.694 47.6872L294.968 44.2109H296.7L296.973 47.6872L295.252 47.8267L294.968 44.3504H296.7L296.415 47.8267L294.694 47.6872Z",
    fill: "#1C3E76"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M297.519 54.6513L298.06 61.6213L296.409 61.755L295.833 54.7908L297.519 54.6513Z",
    fill: "#1C3E76"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M298.606 68.5853L299.153 75.5494L297.566 75.6773L296.99 68.7132L298.606 68.5853Z",
    fill: "#1C3E76"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M299.693 82.5193L300.234 89.4834L298.723 89.6055L298.147 82.6414L299.693 82.5193Z",
    fill: "#1C3E76"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M300.78 96.4476L301.298 103.418L299.909 103.528L299.304 96.5696L300.78 96.4476Z",
    fill: "#1C3E76"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M301.809 110.382L302.315 117.352L301.135 117.45L300.525 110.486L301.809 110.382Z",
    fill: "#1C3E76"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M302.82 124.322L303.332 131.292L302.367 131.367L301.75 124.409L302.82 124.322Z",
    fill: "#1C3E76"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M303.838 138.261L304.309 145.231L303.635 145.284L302.984 138.331L303.838 138.261Z",
    fill: "#1C3E76"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M304.784 152.201L305.255 159.171L304.93 159.2L304.279 152.242L304.784 152.201Z",
    fill: "#1C3E76"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M305.715 166.147L305.936 169.629L305.599 166.159L305.715 166.147Z",
    fill: "#1C3E76"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M329.213 165.525L328.231 162.177L328.341 162.148L329.213 165.525Z",
    fill: "#1C3E76"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M326.272 155.468L324.336 148.754L324.819 148.62L326.592 155.381L326.272 155.468Z",
    fill: "#1C3E76"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M322.393 142.04L320.457 135.332L321.277 135.105L323.05 141.86L322.393 142.04Z",
    fill: "#1C3E76"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M318.551 128.606L316.644 121.886L317.673 121.601L319.481 128.35L318.551 128.606Z",
    fill: "#1C3E76"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M314.738 115.166L312.831 108.44L314.07 108.103L315.872 114.852L314.738 115.166Z",
    fill: "#1C3E76"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M310.924 101.72L309.029 94.9944L310.453 94.5991L312.267 101.348L310.924 101.72Z",
    fill: "#1C3E76"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M307.157 88.2627L305.285 81.5311L306.779 81.1184L308.616 87.8616L307.157 88.2627Z",
    fill: "#1C3E76"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M303.413 74.7996L301.541 68.068L303.105 67.6379L304.942 74.3811L303.413 74.7996Z",
    fill: "#1C3E76"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M299.669 61.3364L297.797 54.6048L299.425 54.1572L301.268 60.8946L299.669 61.3364Z",
    fill: "#1C3E76"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M295.926 47.8732L294.996 44.5132L296.623 43.9203L298.071 47.0942L296.501 47.8093L295.042 44.6411L296.67 44.0482L297.588 47.414L295.926 47.8732Z",
    fill: "#1C3E76"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M300.967 53.4538L303.856 59.8133L302.351 60.4993L299.427 54.1571L300.967 53.4538Z",
    fill: "#1C3E76"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M306.751 66.1729L309.646 72.5325L308.205 73.1894L305.275 66.8473L306.751 66.1729Z",
    fill: "#1C3E76"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M312.541 78.892L315.43 85.2515L314.052 85.8793L311.128 79.5372L312.541 78.892Z",
    fill: "#1C3E76"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M318.325 91.6111L321.197 97.9823L319.929 98.5636L316.976 92.2273L318.325 91.6111Z",
    fill: "#1C3E76"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M324.057 104.353L326.917 110.73L325.841 111.219L322.888 104.894L324.057 104.353Z",
    fill: "#1C3E76"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M329.777 117.102L332.637 123.479L331.759 123.88L328.8 117.555L329.777 117.102Z",
    fill: "#1C3E76"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M335.496 129.856L338.327 136.244L337.705 136.529L334.717 130.21L335.496 129.856Z",
    fill: "#1C3E76"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M341.158 142.633L343.983 149.022L343.686 149.161L340.698 142.842L341.158 142.633Z",
    fill: "#1C3E76"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M346.797 155.416L348.198 158.613L346.692 155.468L346.797 155.416Z",
    fill: "#1C3E76"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M368.666 146.795L366.596 143.987L366.695 143.917L368.666 146.795Z",
    fill: "#1C3E76"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M362.463 138.354L358.348 132.704L358.76 132.413L362.737 138.162L362.463 138.354Z",
    fill: "#1C3E76"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M354.233 127.06L350.117 121.415L350.809 120.921L354.785 126.67L354.233 127.06Z",
    fill: "#1C3E76"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M346.019 115.753L341.932 110.085L342.804 109.469L346.809 115.195L346.019 115.753Z",
    fill: "#1C3E76"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M337.839 104.423L333.752 98.7554L334.793 98.0172L338.798 103.743L337.839 104.423Z",
    fill: "#1C3E76"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M329.661 93.0935L325.58 87.4199L326.783 86.5653L330.794 92.2854L329.661 93.0935Z",
    fill: "#1C3E76"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M321.515 81.7346L317.451 76.0494L318.718 75.1542L322.747 80.8627L321.515 81.7346Z",
    fill: "#1C3E76"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M313.394 70.3641L309.33 64.6789L310.65 63.743L314.684 69.4515L313.394 70.3641Z",
    fill: "#1C3E76"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M305.275 58.9937L301.212 53.3084L302.589 52.3318L306.624 58.0345L305.275 58.9937Z",
    fill: "#1C3E76"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M297.152 47.6232L295.123 44.7864L296.455 43.6703L298.896 46.1583L297.67 47.3733L295.211 44.8911L296.542 43.775L298.553 46.6234L297.152 47.6232Z",
    fill: "#1C3E76"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M303.791 51.1459L308.686 56.1278L307.506 57.2962L302.588 52.3318L303.791 51.1459Z",
    fill: "#1C3E76"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M313.58 61.1155L318.474 66.1031L317.341 67.2192L312.423 62.2548L313.58 61.1155Z",
    fill: "#1C3E76"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M323.37 71.0907L328.264 76.0784L327.183 77.1422L322.265 72.1778L323.37 71.0907Z",
    fill: "#1C3E76"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M333.155 81.0603L338.032 86.0654L337.038 87.0478L332.102 82.1008L333.155 81.0603Z",
    fill: "#1C3E76"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M342.901 91.082L347.767 96.0929L346.924 96.9184L341.983 91.983L342.901 91.082Z",
    fill: "#1C3E76"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M352.639 101.104L357.504 106.115L356.818 106.795L351.871 101.86L352.639 101.104Z",
    fill: "#1C3E76"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M362.369 111.132L367.217 116.166L366.729 116.642L361.765 111.73L362.369 111.132Z",
    fill: "#1C3E76"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M372.062 121.2L376.904 126.234L376.672 126.467L371.702 121.554L372.062 121.2Z",
    fill: "#1C3E76"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M381.735 131.286L384.147 133.809L381.654 131.367L381.735 131.286Z",
    fill: "#1C3E76"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M399.336 115.701L396.435 113.771L396.499 113.672L399.336 115.701Z",
    fill: "#1C3E76"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M390.622 109.888L384.82 105.993L385.105 105.58L390.808 109.62L390.622 109.888Z",
    fill: "#1C3E76"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M379.019 102.098L373.224 98.1974L373.706 97.4999L379.403 101.54L379.019 102.098Z",
    fill: "#1C3E76"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M367.439 94.2793L361.655 90.3555L362.265 89.4718L367.985 93.4829L367.439 94.2793Z",
    fill: "#1C3E76"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M355.877 86.4258L350.099 82.5019L350.826 81.4498L356.546 85.4608L355.877 86.4258Z",
    fill: "#1C3E76"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M344.314 78.578L338.535 74.6484L339.378 73.4276L345.104 77.4387L344.314 78.578Z",
    fill: "#1C3E76"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M332.776 70.6954L327.015 66.7425L327.899 65.4636L333.636 69.4456L332.776 70.6954Z",
    fill: "#1C3E76"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M321.259 62.7837L315.492 58.8308L316.417 57.4996L322.154 61.4816L321.259 62.7837Z",
    fill: "#1C3E76"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M309.738 54.878L303.977 50.9251L304.937 49.5358L310.674 53.5177L309.738 54.878Z",
    fill: "#1C3E76"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M298.218 46.9721L295.34 44.9957L296.207 43.4959L299.357 44.9957L298.613 46.5594L295.463 45.0654L296.329 43.5656L299.195 45.5537L298.218 46.9721Z",
    fill: "#1C3E76"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M305.657 48.0068L311.964 51.018L311.249 52.5178L304.93 49.5357L305.657 48.0068Z",
    fill: "#1C3E76"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M318.266 54.0293L324.573 57.0463L323.893 58.4764L317.574 55.5L318.266 54.0293Z",
    fill: "#1C3E76"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M330.875 60.0574L337.182 63.0686L336.531 64.4405L330.213 61.4583L330.875 60.0574Z",
    fill: "#1C3E76"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M343.482 66.0799L349.778 69.1143L349.179 70.3758L342.849 67.4169L343.482 66.0799Z",
    fill: "#1C3E76"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M356.068 72.1603L362.358 75.2006L361.852 76.2702L355.516 73.3229L356.068 72.1603Z",
    fill: "#1C3E76"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M368.647 78.2466L374.931 81.2927L374.519 82.1647L368.182 79.2174L368.647 78.2466Z",
    fill: "#1C3E76"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M381.223 84.3389L387.501 87.414L387.205 88.0302L380.857 85.112L381.223 84.3389Z",
    fill: "#1C3E76"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M393.772 90.4892L400.044 93.5644L399.905 93.8666L393.557 90.9485L393.772 90.4892Z",
    fill: "#1C3E76"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M406.312 96.657L409.439 98.2033L406.259 96.7616L406.312 96.657Z",
    fill: "#1C3E76"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M417.519 75.997L414.13 75.1716L414.159 75.0611L417.519 75.997Z",
    fill: "#1C3E76"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M407.346 73.5149L400.562 71.8349L400.69 71.3466L407.427 73.1952L407.346 73.5149Z",
    fill: "#1C3E76"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M393.778 70.1549L386.994 68.4807L387.209 67.6553L393.946 69.5038L393.778 70.1549Z",
    fill: "#1C3E76"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M380.221 66.7717L373.443 65.0626L373.716 64.0279L380.46 65.8358L380.221 66.7717Z",
    fill: "#1C3E76"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M366.671 63.3535L359.893 61.6386L360.218 60.4004L366.967 62.2141L366.671 63.3535Z",
    fill: "#1C3E76"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M353.122 59.9295L346.35 58.2088L346.722 56.7788L353.471 58.5867L353.122 59.9295Z",
    fill: "#1C3E76"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M339.584 56.4649L332.817 54.721L333.213 53.2212L339.968 55L339.584 56.4649Z",
    fill: "#1C3E76"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M326.056 52.9771L319.29 51.2331L319.697 49.6636L326.452 51.4424L326.056 52.9771Z",
    fill: "#1C3E76"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M312.524 49.4834L305.757 47.7395L306.182 46.106L312.942 47.8848L312.524 49.4834Z",
    fill: "#1C3E76"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M298.991 45.9955L295.614 45.1235L295.916 43.4145L299.386 43.7458L299.224 45.4665L295.753 45.1468L296.056 43.4377L299.427 44.3271L298.991 45.9955Z",
    fill: "#1C3E76"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M306.344 44.4202L313.297 45.0945L313.14 46.7454L306.181 46.106L306.344 44.4202Z",
    fill: "#1C3E76"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M320.248 45.7689L327.206 46.4432L327.055 48.0244L320.097 47.385L320.248 45.7689Z",
    fill: "#1C3E76"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M334.16 47.1175L341.113 47.7918L340.973 49.3032L334.015 48.6638L334.16 47.1175Z",
    fill: "#1C3E76"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M348.07 48.466L355.017 49.1694L354.889 50.5529L347.931 49.9426L348.07 48.466Z",
    fill: "#1C3E76"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M361.968 49.8788L368.921 50.588L368.811 51.7622L361.846 51.1577L361.968 49.8788Z",
    fill: "#1C3E76"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M375.874 51.2971L382.821 52.0063L382.734 52.9712L375.77 52.3667L375.874 51.2971Z",
    fill: "#1C3E76"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M389.774 52.7213L396.721 53.4596L396.657 54.1397L389.693 53.57L389.774 52.7213Z",
    fill: "#1C3E76"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M403.668 54.2036L410.62 54.9477L410.586 55.279L403.621 54.7093L403.668 54.2036Z",
    fill: "#1C3E76"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M417.567 55.7151L421.031 56.0988L417.555 55.8314L417.567 55.7151Z",
    fill: "#1C3E76"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M421.031 32.4625L417.567 32.8462L417.555 32.7299L421.031 32.4625Z",
    fill: "#1C3E76"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M410.62 33.6136L403.668 34.3519L403.621 33.852L410.586 33.2823L410.62 33.6136Z",
    fill: "#1C3E76"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M396.721 35.0959L389.774 35.84L389.693 34.9971L396.657 34.4216L396.721 35.0959Z",
    fill: "#1C3E76"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M382.821 36.555L375.874 37.2642L375.77 36.1946L382.734 35.5959L382.821 36.555Z",
    fill: "#1C3E76"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M368.921 37.9734L361.968 38.6826L361.846 37.4037L368.811 36.7992L368.921 37.9734Z",
    fill: "#1C3E76"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M355.017 39.3918L348.07 40.0951L347.931 38.6186L354.889 38.0082L355.017 39.3918Z",
    fill: "#1C3E76"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M341.113 40.7696L334.16 41.4439L334.015 39.8976L340.973 39.2582L341.113 40.7696Z",
    fill: "#1C3E76"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M327.206 42.1181L320.248 42.7866L320.097 41.1764L327.055 40.537L327.206 42.1181Z",
    fill: "#1C3E76"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M313.297 43.4609L306.344 44.1352L306.181 42.4552L313.14 41.8158L313.297 43.4609Z",
    fill: "#1C3E76"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M299.386 44.8097L295.916 45.1468L295.614 43.4378L298.991 42.5658L299.427 44.24L296.056 45.1236L295.753 43.4145L299.224 43.0948L299.386 44.8097Z",
    fill: "#1C3E76"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M305.757 40.8218L312.524 39.0721L312.942 40.6765L306.182 42.4611L305.757 40.8218Z",
    fill: "#1C3E76"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M319.29 37.3281L326.056 35.5842L326.452 37.1189L319.697 38.8977L319.29 37.3281Z",
    fill: "#1C3E76"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M332.817 33.8403L339.584 32.0964L339.968 33.5613L333.213 35.3401L332.817 33.8403Z",
    fill: "#1C3E76"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M346.35 30.3465L353.122 28.6317L353.471 29.9803L346.722 31.7824L346.35 30.3465Z",
    fill: "#1C3E76"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M359.893 26.9169L366.671 25.2078L366.967 26.353L360.218 28.1667L359.893 26.9169Z",
    fill: "#1C3E76"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M373.443 23.4988L380.221 21.7897L380.46 22.7256L373.716 24.5393L373.443 23.4988Z",
    fill: "#1C3E76"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M386.994 20.0807L393.778 18.4007L393.946 19.0634L387.209 20.9061L386.994 20.0807Z",
    fill: "#1C3E76"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M400.562 16.7264L407.346 15.0464L407.427 15.3661L400.69 17.2147L400.562 16.7264Z",
    fill: "#1C3E76"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M414.13 13.3897L417.519 12.5643L414.159 13.5002L414.13 13.3897Z",
    fill: "#1C3E76"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M387.495 1.14725L381.223 4.22238L380.857 3.44924L387.205 0.536865L387.495 1.14725Z",
    fill: "#1C3E76"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M374.931 7.26852L368.642 10.3088L368.182 9.3438L374.519 6.39655L374.931 7.26852Z",
    fill: "#1C3E76"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M362.358 13.3548L356.068 16.4009L355.516 15.2383L361.852 12.291L362.358 13.3548Z",
    fill: "#1C3E76"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M349.778 19.4411L343.482 22.4813L342.849 21.1443L349.179 18.1913L349.778 19.4411Z",
    fill: "#1C3E76"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M337.182 25.4927L330.875 28.5039L330.213 27.1029L336.531 24.1266L337.182 25.4927Z",
    fill: "#1C3E76"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M324.573 31.5149L318.266 34.5261L317.574 33.0671L323.893 30.0849L324.573 31.5149Z",
    fill: "#1C3E76"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M311.964 37.5432L305.657 40.5544L304.93 39.0255L311.255 36.0434L311.964 37.5432Z",
    fill: "#1C3E76"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M299.357 43.5656L296.207 45.0654L295.34 43.5656L298.212 41.5891L299.195 43.0134L296.329 44.9956L295.463 43.4958L298.613 42.0077L299.357 43.5656Z",
    fill: "#1C3E76"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M303.972 37.6363L309.733 33.6834L310.675 35.0436L304.937 39.0315L303.972 37.6363Z",
    fill: "#1C3E76"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M315.492 29.7305L321.253 25.7717L322.154 27.0797L316.417 31.0617L315.492 29.7305Z",
    fill: "#1C3E76"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M327.015 21.8187L332.776 17.8658L333.642 19.1156L327.899 23.0976L327.015 21.8187Z",
    fill: "#1C3E76"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M338.535 13.9129L344.314 9.97746L345.104 11.1285L339.378 15.1337L338.535 13.9129Z",
    fill: "#1C3E76"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M350.094 6.0535L355.878 2.12964L356.546 3.10043L350.826 7.1173L350.094 6.0535Z",
    fill: "#1C3E76"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M338.032 2.49007L333.155 7.49517L332.102 6.46043L337.044 1.51928L338.032 2.49007Z",
    fill: "#1C3E76"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M328.258 12.4829L323.37 17.4705L322.265 16.3835L327.183 11.4191L328.258 12.4829Z",
    fill: "#1C3E76"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M318.468 22.4581L313.58 27.4458L312.423 26.3064L317.341 21.342L318.468 22.4581Z",
    fill: "#1C3E76"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M308.686 32.4277L303.791 37.4153L302.588 36.2294L307.506 31.2708L308.686 32.4277Z",
    fill: "#1C3E76"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M298.896 42.403L296.455 44.891L295.123 43.7749L297.146 40.9381L298.559 41.9379L296.542 44.7864L295.211 43.6702L297.67 41.1939L298.896 42.403Z",
    fill: "#1C3E76"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M301.212 35.2529L305.275 29.5676L306.624 30.5268L302.589 36.2295L301.212 35.2529Z",
    fill: "#1C3E76"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M309.33 23.8824L313.394 18.1972L314.684 19.1156L310.656 24.8183L309.33 23.8824Z",
    fill: "#1C3E76"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M317.451 12.506L321.515 6.8208L322.753 7.7044L318.718 13.4071L317.451 12.506Z",
    fill: "#1C3E76"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M325.58 1.1357L329.661 -4.5321L330.794 -3.72407L326.783 1.99604L325.58 1.1357Z",
    fill: "#1C3E76"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M315.43 3.30971L312.535 9.66927L311.128 9.02401L314.052 2.68189L315.43 3.30971Z",
    fill: "#1C3E76"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M309.646 16.0289L306.751 22.3885L305.28 21.7141L308.204 15.372L309.646 16.0289Z",
    fill: "#1C3E76"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M303.856 28.7479L300.961 35.1075L299.427 34.4041L302.351 28.062L303.856 28.7479Z",
    fill: "#1C3E76"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M298.071 41.4671L296.623 44.641L294.996 44.0481L295.926 40.6881L297.594 41.1474L296.67 44.5132L295.042 43.9202L296.501 40.7521L298.071 41.4671Z",
    fill: "#1C3E76"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M297.797 33.9566L299.669 27.225L301.268 27.6668L299.431 34.4042L297.797 33.9566Z",
    fill: "#1C3E76"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M301.541 20.4933L303.413 13.7617L304.942 14.1802L303.105 20.9235L301.541 20.4933Z",
    fill: "#1C3E76"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M305.285 7.03017L307.157 0.298569L308.616 0.699676L306.779 7.4429L305.285 7.03017Z",
    fill: "#1C3E76"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M302.676 226.947C301.598 227.767 300.788 228.887 300.347 230.167C299.906 231.447 299.855 232.829 300.2 234.138C300.545 235.447 301.27 236.624 302.284 237.521C303.298 238.418 304.555 238.994 305.896 239.176C307.237 239.358 308.602 239.139 309.819 238.545C311.036 237.951 312.049 237.01 312.73 235.841C313.412 234.671 313.731 233.326 313.648 231.975C313.565 230.624 313.083 229.328 312.264 228.25C311.165 226.807 309.537 225.858 307.739 225.614C305.941 225.369 304.12 225.849 302.676 226.947V226.947ZM309.897 236.443C309.094 237.057 308.126 237.419 307.117 237.482C306.107 237.546 305.102 237.309 304.227 236.801C303.353 236.293 302.649 235.537 302.204 234.628C301.76 233.72 301.595 232.7 301.73 231.698C301.865 230.696 302.295 229.756 302.964 228.998C303.634 228.24 304.513 227.698 305.491 227.44C306.469 227.182 307.501 227.22 308.458 227.549C309.414 227.878 310.251 228.483 310.863 229.288C311.269 229.82 311.566 230.426 311.737 231.073C311.908 231.719 311.95 232.393 311.86 233.056C311.771 233.718 311.551 234.357 311.214 234.935C310.877 235.513 310.43 236.018 309.897 236.423V236.443Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.284411,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M315.632 235.794L297.918 235.954L298.065 252.058L315.778 251.897L315.632 235.794Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.284411,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M348.153 288.119C348.078 289.697 347.907 291.269 347.642 292.826C347.463 293.874 347.248 294.927 346.983 295.97C346.717 297.012 346.425 297.988 346.073 299.011C346.027 299.138 345.986 299.271 345.935 299.399C345.633 300.278 345.301 301.142 344.948 301.99C344.543 302.937 344.109 303.861 343.645 304.76C343.42 305.2 343.19 305.634 342.95 306.064C342.766 306.391 342.577 306.713 342.383 307.035C341.907 307.837 341.401 308.624 340.849 309.381C340.298 310.137 339.858 310.771 339.316 311.425C338.774 312.079 338.187 312.805 337.594 313.469C337.001 314.134 336.418 314.742 335.8 315.345C335.182 315.948 334.527 316.546 333.858 317.113L333.638 317.297C333.025 317.808 332.386 318.32 331.747 318.831C331.026 319.367 330.29 319.883 329.539 320.364C328.788 320.844 327.909 321.386 327.071 321.856C326.232 322.326 325.379 322.756 324.515 323.165C323.565 323.611 322.595 324.018 321.607 324.386C320.585 324.769 319.563 325.112 318.541 325.408C317.406 325.749 316.259 326.032 315.101 326.257C313.854 326.507 312.586 326.696 311.309 326.829C309.932 326.971 308.548 327.041 307.164 327.039C305.548 327.041 303.933 326.948 302.329 326.758C301.547 326.666 300.77 326.548 299.988 326.41C299.083 326.252 298.184 326.057 297.284 325.838C296.947 325.751 296.605 325.664 296.262 325.567C295.531 325.367 294.806 325.148 294.08 324.902C293.702 324.775 293.329 324.647 292.961 324.509C292.23 324.243 291.514 323.957 290.804 323.65C290.18 323.379 289.562 323.098 288.959 322.792C287.611 322.136 286.304 321.4 285.044 320.589C279.641 317.145 275.124 312.48 271.858 306.968C270.975 305.486 270.186 303.95 269.497 302.368C268.844 300.871 268.284 299.335 267.82 297.769C267.738 297.503 267.662 297.258 267.585 296.966C267.153 295.415 266.812 293.84 266.563 292.249C265.735 286.879 265.98 281.399 267.284 276.124C267.549 275.058 267.861 273.991 268.219 272.925C268.491 272.107 268.788 271.306 269.108 270.523C269.582 269.34 270.108 268.195 270.687 267.088C271.35 265.794 272.087 264.54 272.895 263.332C273.447 262.478 274.04 261.65 274.664 260.858C275.437 259.856 276.25 258.897 277.102 257.981C277.725 257.316 278.364 256.677 279.023 256.054C279.878 255.256 280.763 254.498 281.676 253.779C282.35 253.243 283.045 252.732 283.751 252.246C284.681 251.602 285.647 250.999 286.628 250.432C287.359 250.002 288.105 249.609 288.862 249.231C289.884 248.72 290.906 248.265 291.954 247.851C292.746 247.529 293.553 247.237 294.361 246.972C295.45 246.619 296.548 246.307 297.663 246.047C298.511 245.842 299.37 245.663 300.218 245.536C301.373 245.341 302.543 245.188 303.714 245.096C304.608 245.019 305.508 244.968 306.412 244.963C307.625 244.934 308.837 244.967 310.046 245.06C310.976 245.122 311.917 245.219 312.857 245.357C314.094 245.536 315.336 245.771 316.573 246.067C317.544 246.292 318.51 246.578 319.476 246.869C319.701 246.936 319.931 247.013 320.156 247.089C321.208 247.442 322.236 247.835 323.222 248.26C324.208 248.684 325.236 249.169 326.207 249.686C327.537 250.373 328.824 251.141 330.06 251.985C331.15 252.714 332.201 253.498 333.209 254.336C334.678 255.543 336.06 256.853 337.343 258.257C343.658 265.156 347.433 274.002 348.046 283.336C348.179 284.926 348.215 286.524 348.153 288.119Z",
    fill: "#7D7D7D"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M302.334 259.013H293.814L291.182 250.907L288.55 259.013H280.03L286.925 264.016L284.293 272.122L291.182 267.114L298.077 272.122L295.444 264.016L302.334 259.013ZM321.535 290.7H313.016L310.384 282.6L307.751 290.7H299.232L306.126 295.709L303.494 303.82L310.384 298.811L317.278 303.82L314.646 295.719L321.535 290.7ZM335.294 262.565H326.774L324.142 254.459L321.51 262.565H312.99L319.885 267.568L317.253 275.674L324.142 270.666L331.037 275.674L328.404 267.568L335.294 262.565ZM342.587 306.043L339.955 297.942L337.323 306.043H328.803L335.693 311.052L333.674 317.272L333.894 317.088C334.563 316.52 335.207 315.928 335.836 315.319C336.464 314.711 337.052 314.093 337.63 313.444C338.207 312.795 338.8 312.11 339.352 311.399C339.904 310.689 340.374 310.05 340.885 309.355C341.396 308.66 341.907 307.822 342.419 307.009C342.613 306.687 342.802 306.365 342.986 306.038L342.587 306.043ZM296.303 325.521L293.927 323.793L293.001 324.463C292.271 324.197 291.555 323.911 290.845 323.604C290.221 323.333 289.603 323.052 289 322.745L289.664 320.701L282.775 315.692H291.294L293.927 307.592L296.559 315.692H305.078L298.184 320.701L300.024 326.364L296.303 325.521ZM267.626 296.966L268.025 297.258L267.861 297.769L267.626 296.966ZM266.604 292.249H269.67L272.302 284.148L274.935 292.249H283.454L276.56 297.258L279.192 305.358L272.302 300.35L269.553 302.348",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M348.153 288.119C348.078 289.697 347.907 291.269 347.642 292.826C347.463 293.874 347.248 294.927 346.983 295.97C346.717 297.012 346.425 297.988 346.073 299.011C346.027 299.138 345.986 299.271 345.935 299.399C345.633 300.278 345.301 301.142 344.948 301.99C344.543 302.937 344.109 303.861 343.645 304.76C343.42 305.2 343.19 305.634 342.95 306.064C342.766 306.391 342.577 306.713 342.383 307.035C341.907 307.837 341.401 308.624 340.849 309.381C340.298 310.137 339.858 310.771 339.316 311.425C338.774 312.079 338.187 312.805 337.594 313.469C337.001 314.134 336.418 314.742 335.8 315.345C335.182 315.948 334.527 316.546 333.858 317.113L333.638 317.297C333.025 317.808 332.386 318.32 331.747 318.831C331.026 319.367 330.29 319.883 329.539 320.364C328.788 320.844 327.909 321.386 327.071 321.856C326.232 322.326 325.379 322.756 324.515 323.165C323.565 323.611 322.595 324.018 321.607 324.386C320.585 324.769 319.563 325.112 318.541 325.408C317.406 325.749 316.259 326.032 315.101 326.257C313.854 326.507 312.586 326.696 311.309 326.829C309.932 326.971 308.548 327.041 307.164 327.039C305.548 327.041 303.933 326.948 302.329 326.758C301.547 326.666 300.77 326.548 299.988 326.41C299.083 326.252 298.184 326.057 297.284 325.838C296.947 325.751 296.605 325.664 296.262 325.567C295.531 325.367 294.806 325.148 294.08 324.902C293.702 324.775 293.329 324.647 292.961 324.509C292.23 324.243 291.514 323.957 290.804 323.65C290.18 323.379 289.562 323.098 288.959 322.792C287.611 322.136 286.304 321.4 285.044 320.589C279.641 317.145 275.124 312.48 271.858 306.968C270.975 305.486 270.186 303.95 269.497 302.368C268.844 300.871 268.284 299.335 267.82 297.769C267.738 297.503 267.662 297.258 267.585 296.966C267.153 295.415 266.812 293.84 266.563 292.249C265.735 286.879 265.98 281.399 267.284 276.124C267.549 275.058 267.861 273.991 268.219 272.925C268.491 272.107 268.788 271.306 269.108 270.523C269.582 269.34 270.108 268.195 270.687 267.088C271.35 265.794 272.087 264.54 272.895 263.332C273.447 262.478 274.04 261.65 274.664 260.858C275.437 259.856 276.25 258.897 277.102 257.981C277.725 257.316 278.364 256.677 279.023 256.054C279.878 255.256 280.763 254.498 281.676 253.779C282.35 253.243 283.045 252.732 283.751 252.246C284.681 251.602 285.647 250.999 286.628 250.432C287.359 250.002 288.105 249.609 288.862 249.231C289.884 248.72 290.906 248.265 291.954 247.851C292.746 247.529 293.553 247.237 294.361 246.972C295.45 246.619 296.548 246.307 297.663 246.047C298.511 245.842 299.37 245.663 300.218 245.536C301.373 245.341 302.543 245.188 303.714 245.096C304.608 245.019 305.508 244.968 306.412 244.963C307.625 244.934 308.837 244.967 310.046 245.06C310.976 245.122 311.917 245.219 312.857 245.357C314.094 245.536 315.336 245.771 316.573 246.067C317.544 246.292 318.51 246.578 319.476 246.869C319.701 246.936 319.931 247.013 320.156 247.089C321.208 247.442 322.236 247.835 323.222 248.26C324.208 248.684 325.236 249.169 326.207 249.686C327.537 250.373 328.824 251.141 330.06 251.985C331.15 252.714 332.201 253.498 333.209 254.336C334.678 255.543 336.06 256.853 337.343 258.257C343.658 265.156 347.433 274.002 348.046 283.336C348.179 284.926 348.215 286.524 348.153 288.119Z",
    stroke: "#263238",
    strokeWidth: 0.284411,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M376.13 235.947C374.777 235.948 373.454 236.351 372.33 237.103C371.205 237.856 370.329 238.925 369.811 240.176C369.294 241.426 369.159 242.802 369.424 244.129C369.689 245.456 370.341 246.675 371.298 247.632C372.255 248.588 373.475 249.24 374.802 249.503C376.13 249.767 377.505 249.631 378.755 249.113C380.006 248.595 381.074 247.718 381.826 246.592C382.578 245.467 382.979 244.144 382.979 242.791C382.979 241.892 382.802 241.002 382.457 240.171C382.113 239.34 381.609 238.586 380.973 237.95C380.337 237.315 379.582 236.811 378.751 236.467C377.92 236.123 377.029 235.947 376.13 235.947V235.947ZM376.13 247.876C375.125 247.876 374.141 247.578 373.305 247.019C372.469 246.46 371.817 245.666 371.432 244.737C371.047 243.808 370.946 242.785 371.143 241.799C371.339 240.812 371.823 239.906 372.534 239.195C373.246 238.484 374.152 238 375.138 237.803C376.125 237.607 377.147 237.708 378.076 238.093C379.006 238.478 379.8 239.129 380.359 239.966C380.917 240.802 381.216 241.785 381.216 242.791C381.216 244.142 380.681 245.438 379.728 246.396C378.775 247.354 377.481 247.895 376.13 247.902V247.876Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.284411,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M381.075 250.844L366.884 240.243L357.246 253.145L371.438 263.747L381.075 250.844Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.284411,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M385.6 285.957C385.6 287.066 385.554 288.165 385.472 289.254C385.39 290.342 385.247 291.457 385.068 292.54C384.837 294.019 384.518 295.484 384.112 296.925C383.767 298.189 383.357 299.434 382.886 300.656C381.497 304.264 379.604 307.658 377.264 310.735C372.823 316.592 366.893 321.153 360.091 323.941C358.604 324.558 357.08 325.08 355.527 325.505C354.006 325.938 352.459 326.279 350.897 326.527C349.844 326.691 348.776 326.819 347.702 326.901C346.629 326.982 345.612 327.018 344.549 327.018H344.135C343.205 327.018 342.28 326.972 341.365 326.906C340.343 326.824 339.321 326.706 338.324 326.553C337.465 326.425 336.612 326.267 335.769 326.078C334.925 325.889 333.949 325.653 333.06 325.388C332.171 325.122 331.429 324.877 330.632 324.601C329.835 324.325 328.966 323.972 328.158 323.614C327.351 323.257 326.579 322.904 325.813 322.51C325.046 322.117 324.279 321.682 323.518 321.233C322.756 320.783 321.985 320.277 321.238 319.766C320.492 319.255 319.777 318.744 319.076 318.166C318.376 317.589 317.589 316.945 316.879 316.295C316.168 315.646 315.489 314.977 314.834 314.287C314.18 313.597 313.414 312.754 312.749 311.915C312.085 311.077 311.42 310.224 310.812 309.36C310.132 308.389 309.504 307.392 308.916 306.365C308.282 305.261 307.7 304.123 307.168 302.951C306.591 301.692 306.079 300.404 305.635 299.092C305.12 297.56 304.697 295.998 304.367 294.416C304.017 292.741 303.773 291.046 303.636 289.341C303.548 288.24 303.504 287.129 303.504 286.008C303.504 284.83 303.553 283.663 303.652 282.507C304.115 277.026 305.68 271.695 308.252 266.832C311.474 260.73 316.184 255.54 321.945 251.742C327.707 247.945 334.334 245.662 341.212 245.106C342.309 245.018 343.418 244.973 344.539 244.973C345.403 244.973 346.256 244.999 347.094 245.055C348.362 245.133 349.614 245.268 350.851 245.459C352.287 245.679 353.71 245.98 355.113 246.358C356.101 246.614 357.071 246.91 358.021 247.248C359.217 247.663 360.384 248.13 361.522 248.648C362.35 249.026 363.163 249.43 363.96 249.859C364.982 250.411 365.982 251.007 366.96 251.648C367.686 252.118 368.391 252.614 369.081 253.125C369.986 253.805 370.865 254.525 371.713 255.277C372.352 255.834 372.966 256.416 373.563 257.014C374.361 257.812 375.127 258.645 375.853 259.509C376.412 260.156 376.945 260.824 377.453 261.512C378.133 262.432 378.777 263.372 379.38 264.349C379.843 265.085 380.283 265.839 380.698 266.613C381.25 267.635 381.766 268.703 382.232 269.787C382.589 270.609 382.921 271.448 383.218 272.301C383.627 273.436 383.981 274.594 384.281 275.776C384.516 276.679 384.719 277.599 384.889 278.536C385.114 279.768 385.288 281.02 385.4 282.288C385.492 283.279 385.545 284.281 385.559 285.293C385.6 285.477 385.6 285.722 385.6 285.957Z",
    fill: "#E51E26"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M371.749 255.226C366.454 260.669 358.435 265.473 348.147 271.632C344.569 273.768 340.89 275.981 336.929 278.449C325.642 285.369 317.317 296.222 313.557 308.915C313.25 309.938 312.982 310.927 312.754 311.885C313.436 312.703 314.131 313.493 314.839 314.256C315.146 312.769 315.534 311.19 316.03 309.554C319.632 297.496 327.555 287.19 338.283 280.611C342.223 278.158 345.903 275.95 349.46 273.819C359.723 267.686 368.013 262.703 373.599 256.953C373.001 256.365 372.388 255.783 371.749 255.226ZM375.889 259.457C370.599 264.88 362.601 269.679 352.338 275.812C348.76 277.949 345.075 280.162 341.094 282.63C329.808 289.552 321.482 300.406 317.722 313.101C317.4 314.185 317.114 315.243 316.874 316.26C317.582 316.907 318.315 317.531 319.071 318.13C319.368 316.735 319.741 315.263 320.201 313.735C323.799 301.679 331.721 291.376 342.448 284.802C346.389 282.344 350.069 280.136 353.631 278.005C363.71 271.969 371.887 267.073 377.468 261.456C376.971 260.774 376.444 260.108 375.889 259.457V259.457ZM379.415 264.297C374.131 269.459 366.362 274.11 356.524 280.003C352.946 282.145 349.266 284.353 345.28 286.821C333.994 293.743 325.668 304.597 321.908 317.292C321.656 318.123 321.431 318.938 321.233 319.735C321.972 320.246 322.732 320.735 323.513 321.202C323.758 320.146 324.049 319.054 324.387 317.926C327.984 305.87 335.907 295.567 346.634 288.993C350.575 286.535 354.254 284.327 357.817 282.196C367.343 276.487 375.194 271.8 380.713 266.562C380.315 265.792 379.882 265.037 379.415 264.297ZM382.262 269.735C377.039 274.412 369.751 278.777 360.735 284.189C357.157 286.325 353.478 288.533 349.517 291.007C338.214 297.928 329.877 308.791 326.114 321.498C326.012 321.836 325.915 322.168 325.828 322.521C326.594 322.912 327.376 323.28 328.174 323.624C328.301 323.144 328.445 322.648 328.593 322.153C332.195 310.099 340.116 299.797 350.84 293.22C354.786 290.762 358.466 288.559 362.023 286.422C370.63 281.266 377.867 276.942 383.248 272.291C382.952 271.412 382.62 270.558 382.262 269.735V269.735ZM384.306 275.725C379.298 279.748 372.756 283.668 364.885 288.38C361.307 290.516 357.628 292.729 353.667 295.198C342.72 301.91 334.55 312.332 330.647 324.565C331.445 324.858 332.254 325.12 333.075 325.352C336.798 313.691 344.589 303.756 355.026 297.36C358.972 294.901 362.652 292.699 366.209 290.567C373.543 286.172 379.87 282.39 384.92 278.48C384.753 277.55 384.55 276.632 384.312 275.725H384.306ZM385.426 282.237C380.913 285.477 375.424 288.763 369.071 292.566C365.493 294.702 361.813 296.915 357.853 299.384C347.741 305.579 339.975 314.958 335.774 326.047C336.617 326.236 337.47 326.395 338.329 326.522C342.377 316.149 349.708 307.384 359.202 301.566C363.142 299.108 366.822 296.905 370.379 294.774C376.098 291.349 381.204 288.288 385.574 285.257C385.571 284.235 385.523 283.228 385.431 282.237H385.426ZM373.267 296.751C369.689 298.888 366.004 301.101 362.023 303.569C352.975 309.117 345.781 317.229 341.355 326.875C342.269 326.941 343.195 326.982 344.125 326.987C348.383 318.212 355.063 310.838 363.377 305.736C367.318 303.283 370.998 301.075 374.56 298.944C378.332 296.685 381.838 294.584 385.042 292.54C385.22 291.457 385.354 290.361 385.446 289.254C381.869 291.605 377.79 294.048 373.272 296.751H373.267ZM377.453 300.937C373.875 303.079 370.19 305.287 366.209 307.755C358.529 312.472 352.161 319.048 347.692 326.875C348.765 326.793 349.834 326.665 350.886 326.502C355.087 319.76 360.796 314.086 367.563 309.927C371.504 307.469 375.184 305.261 378.746 303.13C380.156 302.288 381.519 301.464 382.835 300.656C383.306 299.434 383.715 298.189 384.061 296.925C382.017 298.208 379.794 299.522 377.458 300.937H377.453ZM370.446 311.946C364.681 315.496 359.633 320.095 355.563 325.505C357.115 325.08 358.64 324.558 360.127 323.941C363.515 320.113 367.446 316.801 371.795 314.113C373.686 312.938 375.516 311.818 377.299 310.735C378.483 309.177 379.552 307.535 380.499 305.823C377.274 307.745 373.957 309.743 370.446 311.946ZM367.016 251.597C361.732 256.815 353.912 261.497 343.987 267.441C340.409 269.577 336.724 271.79 332.743 274.259C321.456 281.177 313.13 292.03 309.371 304.724C309.212 305.261 309.059 305.788 308.921 306.309C309.509 307.331 310.137 308.353 310.817 309.304C311.093 308.041 311.436 306.748 311.839 305.363C315.439 293.306 323.363 283.001 334.092 276.426C338.033 273.967 341.712 271.764 345.27 269.633C355.353 263.592 363.531 258.691 369.112 253.069L367.016 251.597ZM305.686 299.041C309.634 286.986 317.731 276.723 328.537 270.078C332.497 267.604 336.203 265.396 339.755 263.26C348.929 257.766 356.299 253.345 361.537 248.597C362.365 248.975 363.178 249.379 363.975 249.808C358.43 255.052 350.6 259.739 341.068 265.452C337.491 267.584 333.831 269.787 329.886 272.245C319.161 278.823 311.239 289.127 307.638 301.183C307.464 301.765 307.301 302.338 307.153 302.9L305.686 299.041ZM303.657 289.3C308.076 279.611 315.289 271.463 324.371 265.902C328.332 263.429 332.038 261.221 335.59 259.079C343.532 254.321 350.125 250.391 355.149 246.302C356.137 246.558 357.106 246.854 358.057 247.191C352.665 251.817 345.474 256.125 336.903 261.256C333.325 263.393 329.661 265.596 325.72 268.054C315.802 274.115 308.27 283.403 304.388 294.36L303.657 289.3ZM304.74 276.012C308.906 270.282 314.151 265.42 320.18 261.701C324.141 259.233 327.847 257.025 331.424 254.883C337.486 251.254 342.755 248.096 347.15 245.004C348.418 245.082 349.67 245.217 350.907 245.408C345.914 249.164 339.78 252.839 332.717 257.101C329.14 259.233 325.475 261.44 321.535 263.899C314.092 268.467 307.943 274.864 303.672 282.482L304.74 276.012ZM313.465 259.176C314.279 258.604 315.122 258.047 315.994 257.505C319.955 255.037 323.661 252.824 327.238 250.687C329.942 249.067 332.492 247.539 334.874 246.087C336.971 245.577 339.106 245.235 341.258 245.065C337.475 247.554 333.218 250.105 328.552 252.9C324.974 255.031 321.31 257.239 317.369 259.693C314.097 261.723 311.055 264.104 308.297 266.792L313.465 259.176Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M385.6 285.957C385.6 287.066 385.554 288.165 385.472 289.254C385.39 290.342 385.247 291.457 385.068 292.54C384.837 294.019 384.518 295.484 384.112 296.925C383.767 298.189 383.357 299.434 382.886 300.656C381.497 304.264 379.604 307.658 377.264 310.735C372.823 316.592 366.893 321.153 360.091 323.941C358.604 324.558 357.08 325.08 355.527 325.505C354.006 325.938 352.459 326.279 350.897 326.527C349.844 326.691 348.776 326.819 347.702 326.901C346.629 326.982 345.612 327.018 344.549 327.018H344.135C343.205 327.018 342.28 326.972 341.365 326.906C340.343 326.824 339.321 326.706 338.324 326.553C337.465 326.425 336.612 326.267 335.769 326.078C334.925 325.889 333.949 325.653 333.06 325.388C332.171 325.122 331.429 324.877 330.632 324.601C329.835 324.325 328.966 323.972 328.158 323.614C327.351 323.257 326.579 322.904 325.813 322.51C325.046 322.117 324.279 321.682 323.518 321.233C322.756 320.783 321.985 320.277 321.238 319.766C320.492 319.255 319.777 318.744 319.076 318.166C318.376 317.589 317.589 316.945 316.879 316.295C316.168 315.646 315.489 314.977 314.834 314.287C314.18 313.597 313.414 312.754 312.749 311.915C312.085 311.077 311.42 310.224 310.812 309.36C310.132 308.389 309.504 307.392 308.916 306.365C308.282 305.261 307.7 304.123 307.168 302.951C306.591 301.692 306.079 300.404 305.635 299.092C305.12 297.56 304.697 295.998 304.367 294.416C304.017 292.741 303.773 291.046 303.636 289.341C303.548 288.24 303.504 287.129 303.504 286.008C303.504 284.83 303.553 283.663 303.652 282.507C304.115 277.026 305.68 271.695 308.252 266.832C311.474 260.73 316.184 255.54 321.945 251.742C327.707 247.945 334.334 245.662 341.212 245.106C342.309 245.018 343.418 244.973 344.539 244.973C345.403 244.973 346.256 244.999 347.094 245.055C348.362 245.133 349.614 245.268 350.851 245.459C352.287 245.679 353.71 245.98 355.113 246.358C356.101 246.614 357.071 246.91 358.021 247.248C359.217 247.663 360.384 248.13 361.522 248.648C362.35 249.026 363.163 249.43 363.96 249.859C364.982 250.411 365.982 251.007 366.96 251.648C367.686 252.118 368.391 252.614 369.081 253.125C369.986 253.805 370.865 254.525 371.713 255.277C372.352 255.834 372.966 256.416 373.563 257.014C374.361 257.812 375.127 258.645 375.853 259.509C376.412 260.156 376.945 260.824 377.453 261.512C378.133 262.432 378.777 263.372 379.38 264.349C379.843 265.085 380.283 265.839 380.698 266.613C381.25 267.635 381.766 268.703 382.232 269.787C382.589 270.609 382.921 271.448 383.218 272.301C383.627 273.436 383.981 274.594 384.281 275.776C384.516 276.679 384.719 277.599 384.889 278.536C385.114 279.768 385.288 281.02 385.4 282.288C385.492 283.279 385.545 284.281 385.559 285.293C385.6 285.477 385.6 285.722 385.6 285.957Z",
    stroke: "#263238",
    strokeWidth: 0.284411,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M333.807 292.193C344.781 292.193 353.678 283.296 353.678 272.322C353.678 261.347 344.781 252.45 333.807 252.45C322.832 252.45 313.936 261.347 313.936 272.322C313.936 283.296 322.832 292.193 333.807 292.193Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M334.577 265.516C335.403 261.996 333.219 258.473 329.699 257.646C326.179 256.82 322.656 259.004 321.829 262.524C321.003 266.044 323.187 269.568 326.707 270.394C330.227 271.22 333.751 269.036 334.577 265.516Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 241.054,
    y: 196.088,
    width: 189.967,
    height: 167.453
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10.55px)",
      clipPath: "url(#bgblur_1_112_3_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 21.1075,
    x: 262.161,
    y: 217.195,
    width: 147.752,
    height: 125.238,
    rx: 62.6189,
    fill: "url(#paint0_linear_112_3)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M508.884 72.7956L524.868 109.048L564.256 104.763L540.852 136.73L564.256 168.697L524.868 164.412L508.884 200.665L492.901 164.412L453.513 168.697L476.917 136.73L453.513 104.763L492.901 109.048L508.884 72.7956Z",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M508.884 72.7956V200.665",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M524.867 109.048L509.437 135.202L492.9 109.048",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M492.9 164.412L509.437 135.202L524.867 164.412",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M564.255 104.763L509.436 135.202L564.255 168.697",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M453.513 104.763L509.437 135.202L453.513 168.697",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M476.916 136.73H540.858",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M508.84 65.9571C508.119 65.9499 507.412 66.1571 506.809 66.5524C506.206 66.9477 505.734 67.5132 505.453 68.1772C505.172 68.8413 505.095 69.5738 505.231 70.2818C505.368 70.9898 505.711 71.6413 506.218 72.1537C506.726 72.6661 507.374 73.0162 508.08 73.1595C508.787 73.3028 509.52 73.2329 510.187 72.9587C510.854 72.6845 511.424 72.2183 511.825 71.6194C512.227 71.0204 512.441 70.3157 512.441 69.5947C512.441 68.6362 512.063 67.7164 511.389 67.0353C510.714 66.3541 509.798 65.9667 508.84 65.9571V65.9571ZM508.84 71.5808C508.439 71.5822 508.047 71.4647 507.714 71.243C507.38 71.0213 507.119 70.7055 506.966 70.3356C506.812 69.9658 506.771 69.5585 506.849 69.1655C506.926 68.7725 507.119 68.4115 507.403 68.1282C507.686 67.8449 508.047 67.6521 508.44 67.5743C508.833 67.4965 509.24 67.5372 509.61 67.6912C509.98 67.8451 510.296 68.1055 510.517 68.4392C510.739 68.7729 510.857 69.1649 510.855 69.5656C510.855 70.1001 510.643 70.6126 510.265 70.9906C509.887 71.3685 509.374 71.5808 508.84 71.5808Z",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M508.841 67.543V7.62939e-06",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M142.32 129.724L158.304 165.977L197.692 161.691L174.288 193.659L197.692 225.626L158.304 221.348L142.32 257.601L126.337 221.348L86.9487 225.626L110.353 193.659L86.9487 161.691L126.337 165.977L142.32 129.724Z",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M142.32 129.724V257.601",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M158.303 165.977L142.872 192.138L126.336 165.977",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M126.336 221.348L142.872 192.138L158.303 221.348",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M197.693 161.692L142.874 192.138L197.693 225.626",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9487 161.692L142.873 192.138L86.9487 225.626",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M110.354 193.659H174.289",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M142.27 122.885C141.551 122.885 140.847 123.099 140.249 123.499C139.651 123.898 139.185 124.466 138.909 125.131C138.634 125.796 138.562 126.527 138.702 127.233C138.843 127.938 139.189 128.587 139.698 129.095C140.207 129.604 140.855 129.95 141.56 130.091C142.266 130.231 142.997 130.159 143.662 129.884C144.327 129.608 144.895 129.142 145.295 128.544C145.694 127.946 145.908 127.243 145.908 126.523C145.908 125.558 145.524 124.633 144.842 123.951C144.16 123.269 143.235 122.885 142.27 122.885ZM142.27 128.516C141.87 128.516 141.479 128.398 141.146 128.176C140.814 127.953 140.555 127.638 140.401 127.268C140.248 126.898 140.208 126.492 140.286 126.099C140.364 125.707 140.557 125.347 140.84 125.064C141.123 124.781 141.483 124.588 141.875 124.51C142.268 124.432 142.674 124.472 143.044 124.625C143.414 124.779 143.729 125.038 143.952 125.37C144.174 125.703 144.293 126.094 144.293 126.494C144.293 127.03 144.079 127.545 143.7 127.924C143.321 128.303 142.806 128.516 142.27 128.516V128.516Z",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M142.269 124.472V-47.7253",
    stroke: "#263238",
    strokeWidth: 0.404852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M400.244 -0.653698C400.348 -0.653698 400.437 32.4541 400.437 73.2783C400.437 114.103 400.348 147.21 400.244 147.21C400.139 147.21 400.05 114.11 400.05 73.2783C400.05 32.4466 400.139 -0.653698 400.244 -0.653698Z",
    fill: "#263238"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M401.062 164.14C397.866 164.14 396.258 153.363 396.258 151.18C396.258 148.149 398.142 146.19 401.062 146.19C403.981 146.19 405.858 148.149 405.858 151.18C405.858 153.363 404.25 164.14 401.062 164.14ZM401.062 147.627C398.954 147.627 397.695 148.953 397.695 151.18C397.695 154.845 399.81 162.703 401.062 162.703C402.313 162.703 404.421 154.845 404.421 151.18C404.421 148.953 403.162 147.62 401.062 147.62V147.627Z",
    fill: "#E0E0E0"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M432.952 205.582C437.162 187.966 426.294 170.272 408.678 166.062C391.062 161.853 373.368 172.721 369.159 190.337C364.949 207.953 375.817 225.646 393.433 229.856C411.049 234.066 428.742 223.198 432.952 205.582Z",
    fill: "#E51E26"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M371.401 212.026C373.928 217.346 377.838 221.889 382.723 225.179C388.838 225.41 395.229 225.529 401.805 225.529C407.809 225.529 413.641 225.433 419.257 225.239C424.151 221.963 428.077 217.433 430.623 212.122C421.685 212.651 412.002 212.942 401.805 212.942C391.043 212.942 380.779 212.614 371.401 212.026Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M430.513 183.551C428.15 178.748 424.65 174.596 420.316 171.455C414.358 171.663 408.206 171.782 401.83 171.782C394.933 171.782 388.244 171.648 381.868 171.402C377.531 174.537 374.024 178.681 371.649 183.476C380.945 184.057 391.134 184.37 401.83 184.37C411.959 184.355 421.627 184.072 430.513 183.551Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M433.111 191.044C423.533 191.669 412.956 192.012 401.828 192.012C390.112 192.012 379.014 191.625 369.056 190.939C368.152 195.075 368.054 199.346 368.765 203.52C378.828 204.212 390.038 204.607 401.858 204.607C413.075 204.607 423.734 204.25 433.387 203.624C434.117 199.454 434.033 195.182 433.141 191.044H433.111Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M418.171 169.965C423.615 175.755 426.77 183.326 427.048 191.268C427.326 199.211 424.708 206.983 419.682 213.14C414.656 219.296 407.565 223.416 399.727 224.734C391.89 226.051 383.841 224.476 377.079 220.301C380.275 223.701 384.161 226.379 388.477 228.155C392.792 229.932 397.437 230.767 402.101 230.604C406.765 230.44 411.34 229.283 415.521 227.209C419.701 225.135 423.39 222.191 426.342 218.576C429.293 214.961 431.438 210.757 432.634 206.246C433.829 201.735 434.047 197.021 433.274 192.419C432.5 187.817 430.753 183.433 428.148 179.56C425.543 175.688 422.142 172.417 418.171 169.965V169.965Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M384.76 210.149C390.856 210.149 395.798 202.225 395.798 192.451C395.798 182.678 390.856 174.754 384.76 174.754C378.664 174.754 373.721 182.678 373.721 192.451C373.721 202.225 378.664 210.149 384.76 210.149Z",
    fill: "white"
  })))), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M433.753 198.03C433.753 198.03 433.753 197.851 433.708 197.501C433.663 197.151 433.649 196.622 433.604 195.945C433.604 195.602 433.581 195.222 433.537 194.805C433.5 194.38 433.41 193.926 433.336 193.435C433.261 192.943 433.172 192.407 433.082 191.841C432.993 191.275 432.799 190.686 432.658 190.053C431.894 186.992 430.671 184.064 429.031 181.368C426.888 177.78 424.073 174.639 420.741 172.117L419.325 171.067C418.834 170.747 418.312 170.449 417.836 170.129C417.359 169.808 416.808 169.466 416.242 169.213L414.551 168.401L413.694 167.991L412.786 167.663L410.953 166.993C410.335 166.784 409.68 166.65 409.032 166.479C408.387 166.288 407.73 166.139 407.065 166.032C405.705 165.778 404.329 165.619 402.947 165.555C402.246 165.555 401.539 165.459 400.824 165.474L398.664 165.585C398.306 165.585 397.919 165.585 397.576 165.652L396.496 165.824C395.751 165.943 395.007 166.025 394.299 166.181C392.827 166.507 391.379 166.933 389.964 167.455C388.507 167.974 387.088 168.597 385.719 169.317C385.026 169.689 384.37 170.121 383.685 170.531C383.357 170.739 383 170.926 382.68 171.164L381.726 171.909C380.417 172.873 379.172 173.923 378.002 175.052L376.349 176.869L375.931 177.331L375.559 177.823L374.814 178.821L374.069 179.826L373.414 180.892L372.759 181.972L372.431 182.515L372.155 183.081C371.79 183.826 371.41 184.608 371.053 185.375L370.166 187.789C367.922 194.45 367.922 201.663 370.166 208.324C370.457 209.136 370.755 209.94 371.045 210.737C371.336 211.534 371.79 212.271 372.155 213.031L372.431 213.605L372.759 214.141L373.414 215.221L374.069 216.293L374.814 217.299L375.559 218.29L375.939 218.789L376.349 219.243L378.01 221.068C379.168 222.196 380.399 223.246 381.697 224.211L382.657 224.956C382.978 225.194 383.335 225.38 383.663 225.589C384.348 225.999 385.004 226.431 385.689 226.803C387.062 227.522 388.483 228.147 389.942 228.673C391.361 229.189 392.811 229.614 394.284 229.946C395.029 230.095 395.774 230.177 396.474 230.296L397.561 230.468C397.919 230.512 398.306 230.512 398.649 230.535L400.801 230.646C401.546 230.646 402.224 230.587 402.924 230.564C404.307 230.501 405.683 230.342 407.043 230.088C407.71 229.98 408.369 229.831 409.017 229.641C409.657 229.469 410.313 229.335 410.931 229.127L412.771 228.457L413.672 228.129L414.529 227.719L416.227 226.907C416.786 226.654 417.285 226.289 417.813 225.991C418.342 225.693 418.849 225.373 419.348 225.053L420.755 224.002C424.086 221.479 426.901 218.338 429.045 214.752C430.684 212.056 431.907 209.128 432.673 206.067C432.814 205.434 433.03 204.853 433.097 204.279C433.164 203.706 433.269 203.177 433.351 202.685C433.433 202.194 433.514 201.739 433.552 201.315C433.589 200.89 433.604 200.518 433.619 200.175C433.663 199.497 433.693 198.984 433.723 198.619C433.753 198.254 433.768 198.09 433.768 198.09C433.768 198.09 433.768 198.268 433.768 198.619C433.768 198.969 433.73 199.505 433.708 200.175C433.708 200.525 433.708 200.92 433.656 201.33C433.604 201.739 433.537 202.201 433.47 202.7C433.403 203.199 433.321 203.736 433.231 204.302C433.128 204.909 432.991 205.511 432.822 206.104C432.083 209.19 430.875 212.144 429.239 214.863C427.097 218.488 424.275 221.665 420.927 224.218L419.512 225.284C419.013 225.611 418.491 225.917 417.97 226.237C417.448 226.557 416.934 226.907 416.368 227.168L414.663 227.995L413.799 228.412L412.883 228.747L411.035 229.425C410.41 229.633 409.747 229.767 409.099 229.946C408.446 230.142 407.782 230.296 407.11 230.408C405.737 230.663 404.349 230.828 402.954 230.9C402.209 230.9 401.524 230.996 400.809 230.982L398.627 230.877C398.262 230.877 397.882 230.877 397.532 230.81L396.429 230.639C395.684 230.52 394.94 230.438 394.195 230.281C391.172 229.614 388.249 228.552 385.503 227.123C384.81 226.751 384.14 226.311 383.454 225.902C383.119 225.686 382.754 225.5 382.434 225.261L381.466 224.516C380.158 223.539 378.914 222.479 377.741 221.343L376.066 219.504L375.641 219.034L375.269 218.535L374.524 217.53L373.779 216.517L373.109 215.429L372.446 214.342L372.118 213.791L371.835 213.217C371.462 212.453 371.09 211.678 370.718 210.893C370.42 210.089 370.122 209.27 369.816 208.458C367.547 201.717 367.547 194.418 369.816 187.677L370.71 185.234L371.827 182.91L372.111 182.337L372.446 181.793L373.109 180.698L373.771 179.618L374.516 178.605L375.261 177.599L375.641 177.093L376.058 176.631L377.734 174.791C378.907 173.656 380.151 172.596 381.458 171.618L382.426 170.874C382.747 170.635 383.112 170.449 383.447 170.233C384.132 169.823 384.802 169.384 385.495 169.011C388.242 167.583 391.164 166.521 394.187 165.853C394.932 165.697 395.677 165.615 396.422 165.496L397.524 165.332C397.889 165.28 398.269 165.287 398.619 165.258L400.794 165.153C401.539 165.153 402.232 165.213 402.939 165.243C404.337 165.307 405.728 165.471 407.103 165.734C407.775 165.84 408.44 165.992 409.091 166.189C409.739 166.367 410.402 166.501 411.028 166.71L412.875 167.388L413.784 167.723L414.655 168.14L416.361 168.967C416.927 169.227 417.434 169.592 417.962 169.898C418.491 170.203 419.005 170.524 419.504 170.851L420.919 171.916C424.267 174.47 427.09 177.647 429.232 181.271C430.868 183.99 432.076 186.945 432.814 190.031C432.983 190.624 433.12 191.225 433.224 191.833C433.313 192.399 433.388 192.935 433.462 193.435C433.537 193.934 433.611 194.388 433.649 194.805C433.686 195.222 433.686 195.609 433.701 195.96C433.701 196.63 433.745 197.151 433.76 197.516C433.775 197.881 433.753 198.03 433.753 198.03Z",
    fill: "#263238"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M390.335 166.986C397.444 168.048 404.671 168.048 411.779 166.986V159.21C404.671 158.147 397.444 158.147 390.335 159.21V166.986Z",
    fill: "#455A64"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M408.136 158.792C408.141 160.164 407.629 161.487 406.703 162.498C405.777 163.51 404.504 164.136 403.138 164.252C401.328 164.394 399.414 164.461 397.41 164.461C394.9 164.461 392.532 164.334 390.334 164.125V166.986C397.443 168.048 404.67 168.048 411.778 166.986V159.21C410.653 159.023 409.387 158.874 408.136 158.792Z",
    fill: "black"
  })))), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1809 3.4212C56.2851 3.4212 56.3745 21.8781 56.3745 44.6476C56.3745 67.4172 56.2851 85.8741 56.1809 85.8741C56.0766 85.8741 55.9872 67.4172 55.9872 44.6476C55.9872 21.8781 56.0691 3.4212 56.1809 3.4212Z",
    fill: "#263238"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8168 103.162C52.6289 103.162 51.0201 92.384 51.0201 90.1942C51.0201 87.1627 52.9045 85.2038 55.8168 85.2038C58.7291 85.2038 60.6209 87.1627 60.6209 90.1942C60.6209 92.384 59.0047 103.162 55.8168 103.162ZM55.8168 86.6488C53.7164 86.6488 52.4576 87.9746 52.4576 90.1942C52.4576 93.8662 54.5655 101.717 55.8168 101.717C57.0681 101.717 59.176 93.8662 59.176 90.1942C59.176 87.9746 57.9247 86.6488 55.8168 86.6488Z",
    fill: "#E0E0E0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8601 147.164C92.4749 129.958 83.0779 111.457 65.8714 105.843C48.6648 100.228 30.1645 109.625 24.5497 126.831C18.935 144.038 28.332 162.538 45.5385 168.153C62.7451 173.768 81.2454 164.371 86.8601 147.164Z",
    fill: "#E51E26"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9343 109.016C78.383 114.806 81.5414 122.379 81.821 130.324C82.1006 138.27 79.4824 146.046 74.454 152.204C69.4257 158.362 62.3301 162.483 54.4892 163.798C46.6483 165.113 38.5968 163.533 31.8344 159.352C35.0318 162.749 38.9176 165.425 43.232 167.2C47.5465 168.974 52.1902 169.808 56.8525 169.644C61.5149 169.48 66.0885 168.322 70.2676 166.248C74.4466 164.174 78.1347 161.232 81.0853 157.619C84.0359 154.005 86.181 149.803 87.3771 145.294C88.5733 140.784 88.7928 136.072 88.0212 131.471C87.2496 126.87 85.5045 122.486 82.9027 118.614C80.3009 114.742 76.9024 111.469 72.9343 109.016V109.016Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1556 123.205C41.126 126.84 36.0239 127.749 33.7596 125.231C31.4953 122.714 32.9254 117.738 36.9549 114.103C40.9845 110.469 46.094 109.567 48.3583 112.077C50.6226 114.587 49.1925 119.578 45.1556 123.205Z",
    fill: "white"
  })))), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5147 137.052C88.5147 137.052 88.5147 136.873 88.4626 136.523C88.4104 136.173 88.4104 135.644 88.3658 134.966C88.3658 134.623 88.3211 134.221 88.2987 133.819C88.2764 133.417 88.1647 132.947 88.0902 132.456C88.0157 131.964 87.9338 131.428 87.8444 130.862C87.755 130.296 87.5613 129.707 87.4124 129.074C86.6628 126.015 85.4549 123.087 83.8297 120.39C81.684 116.802 78.8668 113.661 75.5323 111.139L74.1246 110.089C73.633 109.761 73.1116 109.463 72.5902 109.15C72.0688 108.837 71.5698 108.487 71.0037 108.227L69.313 107.415L68.4117 107.035L67.5105 106.7L65.6782 106.037C65.0525 105.828 64.4045 105.694 63.7565 105.523C63.109 105.331 62.4497 105.182 61.7827 105.076C60.425 104.821 59.0512 104.662 57.6712 104.599C56.9636 104.599 56.2561 104.502 55.5485 104.517L53.3885 104.629C53.0309 104.629 52.6436 104.629 52.301 104.696L51.2135 104.867C50.4687 104.986 49.7239 105.068 49.0237 105.217C47.5507 105.549 46.1003 105.975 44.6814 106.491C43.2257 107.018 41.8073 107.643 40.4358 108.361C39.7506 108.733 39.0877 109.165 38.4099 109.567C38.0747 109.783 37.7246 109.962 37.4044 110.208L36.4435 110.953C35.1355 111.916 33.8915 112.963 32.7194 114.088L31.0584 115.913L30.6487 116.375L30.2689 116.867L29.524 117.865L28.7792 118.863L28.1238 119.935L27.4683 121.015L27.1406 121.552L26.865 122.125C26.4926 122.87 26.1202 123.652 25.7552 124.419C25.3902 125.186 25.1668 126.021 24.8763 126.832C22.6367 133.494 22.6367 140.706 24.8763 147.367C25.1742 148.172 25.4722 148.976 25.7626 149.781C26.0531 150.585 26.5075 151.315 26.865 152.075L27.148 152.648L27.4758 153.185L28.1312 154.265L28.7867 155.337L29.5315 156.335L30.2763 157.333L30.6487 157.832L31.0658 158.287L32.7194 160.111C33.8913 161.237 35.1354 162.284 36.4435 163.247L37.4044 163.992C37.7172 164.23 38.0747 164.409 38.4099 164.625C39.0877 165.027 39.7506 165.467 40.4358 165.839C43.1527 167.247 46.0389 168.301 49.0237 168.975C49.7686 169.131 50.5134 169.213 51.2135 169.333L52.301 169.504C52.666 169.549 53.0458 169.549 53.3885 169.571L55.5261 169.601C56.271 169.601 56.9413 169.541 57.6489 169.519C59.0312 169.455 60.4075 169.296 61.7678 169.042C62.4322 168.935 63.089 168.786 63.7342 168.595C64.3822 168.416 65.0376 168.29 65.6558 168.081L67.4881 167.411L68.3968 167.083L69.2534 166.673L70.9665 165.876C71.5326 165.623 72.0316 165.258 72.5604 164.96C73.0893 164.662 73.5957 164.342 74.0501 164.022L75.4653 162.972C78.8216 160.451 81.6614 157.308 83.8297 153.713C85.455 151.013 86.6628 148.083 87.4124 145.021C87.5613 144.396 87.7699 143.815 87.8444 143.241C87.9189 142.668 88.0157 142.139 88.0902 141.647C88.1647 141.156 88.254 140.694 88.2987 140.277C88.3434 139.86 88.3434 139.48 88.3658 139.137C88.4104 138.459 88.4402 137.945 88.4626 137.58C88.4849 137.215 88.5147 137.052 88.5147 137.052C88.5147 137.052 88.5147 137.23 88.5147 137.58C88.5147 137.93 88.5147 138.459 88.4551 139.137C88.4551 139.48 88.4551 139.882 88.403 140.284C88.3509 140.686 88.2838 141.163 88.2168 141.662C88.1498 142.161 88.0604 142.69 87.9784 143.263C87.8745 143.869 87.7377 144.468 87.5688 145.058C86.8286 148.146 85.6204 151.103 83.9861 153.825C81.831 157.452 78.996 160.628 75.6366 163.18L74.2214 164.245C73.7224 164.573 73.1935 164.878 72.6796 165.199C72.1657 165.519 71.6443 165.869 71.0782 166.13L69.3725 166.957L68.5011 167.366L67.5924 167.701L65.7452 168.387C65.1121 168.595 64.4567 168.729 63.8087 168.908C63.1561 169.101 62.4918 169.253 61.8199 169.362C60.4456 169.625 59.0542 169.79 57.6563 169.854C56.9115 169.854 56.2337 169.951 55.5112 169.943L53.3363 169.839C52.9713 169.839 52.5915 169.839 52.234 169.765L51.1689 169.601C50.424 169.481 49.6792 169.4 48.9344 169.243C47.442 168.917 45.9738 168.489 44.5399 167.962C43.0658 167.436 41.6298 166.809 40.2422 166.085C39.5495 165.705 38.8791 165.273 38.1939 164.864C37.8513 164.648 37.4937 164.461 37.1735 164.223L36.2052 163.478C34.8946 162.507 33.6504 161.45 32.481 160.313L30.8052 158.465L30.3806 158.004L30.0007 157.505L29.2559 156.499L28.5111 155.486L27.8482 154.399L27.1853 153.311L26.8501 152.76L26.5745 152.186C26.2021 151.442 25.8297 150.637 25.4498 149.863L24.556 147.427C22.287 140.683 22.287 133.382 24.556 126.639L25.4498 124.203L26.5671 121.879L26.8501 121.306L27.1778 120.755L27.8407 119.667L28.5111 118.587L29.2559 117.574L30.0007 116.561L30.3732 116.062L30.7977 115.6L32.4736 113.761C33.6426 112.621 34.8868 111.561 36.1977 110.588L37.166 109.843C37.4863 109.597 37.8438 109.418 38.1864 109.202C38.8717 108.793 39.542 108.353 40.2347 107.981C41.6223 107.255 43.0582 106.625 44.5324 106.096C45.9675 105.573 47.4355 105.145 48.9269 104.815C49.6717 104.666 50.4166 104.584 51.1614 104.465L52.2563 104.294C52.6213 104.249 53.0011 104.249 53.3587 104.227L55.5336 104.122C56.2784 104.122 56.9711 104.182 57.6787 104.204C59.0734 104.276 60.4619 104.44 61.8348 104.696C62.5083 104.81 63.1748 104.961 63.831 105.15C64.479 105.329 65.1345 105.471 65.7676 105.679L67.6147 106.357L68.5234 106.692L69.3949 107.109L71.0931 107.929C71.6666 108.189 72.1657 108.562 72.6945 108.867C73.2233 109.172 73.7447 109.485 74.2363 109.82L75.6589 110.886C79.0083 113.437 81.8312 116.614 83.9712 120.241C85.6089 122.972 86.8172 125.939 87.5539 129.037C87.7221 129.628 87.8588 130.227 87.9635 130.832C88.0455 131.406 88.1274 131.942 88.2019 132.441C88.2764 132.94 88.3509 133.394 88.3881 133.811C88.4253 134.229 88.4253 134.616 88.4402 134.959C88.4402 135.636 88.4849 136.158 88.4998 136.523C88.5147 136.888 88.5147 137.052 88.5147 137.052Z",
    fill: "#263238"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0978 105.985C48.6467 106.53 52.233 106.794 55.8234 106.774C59.4138 106.794 63.0002 106.53 66.549 105.985V98.2235C63.0002 97.6783 59.4138 97.4143 55.8234 97.434C52.233 97.4146 48.6467 97.6786 45.0978 98.2235V105.985Z",
    fill: "#455A64"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8991 97.7766C62.904 99.148 62.3926 100.471 61.4666 101.483C60.5405 102.494 59.2677 103.12 57.9012 103.236C56.0913 103.37 54.1771 103.445 52.1735 103.445C49.6634 103.445 47.2874 103.318 45.0901 103.11V105.985C48.639 106.53 52.2253 106.794 55.8157 106.774C59.4061 106.794 62.9925 106.53 66.5413 105.985V98.2235C65.4166 98.0447 64.1802 97.8957 62.8991 97.7766Z",
    fill: "black"
  })))), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0098 157.922C55.9055 157.922 55.8161 148.179 55.8161 136.165C55.8161 124.151 55.9055 114.409 56.0098 114.409C56.114 114.409 56.2109 124.151 56.2109 136.165C56.2109 148.179 56.1215 157.922 56.0098 157.922Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2339 147.397C75.1817 147.494 66.5342 142.578 55.9204 136.426C45.3065 130.274 36.741 125.209 36.7931 125.119C36.8452 125.03 45.4927 129.938 56.114 136.083C66.7353 142.228 75.286 147.308 75.2339 147.397Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2707 146.824C37.2185 146.734 45.5681 141.967 55.8915 136.188C66.2148 130.408 74.6761 125.76 74.7283 125.887C74.7804 126.013 66.4308 130.743 56.1075 136.523C45.7841 142.303 37.3228 146.921 37.2707 146.824Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1359 124.382C60.7219 124.955 60.2556 125.489 59.7431 125.976C58.8419 126.929 57.5905 128.21 56.1828 129.633L56.0413 129.767L55.9072 129.626C54.5218 128.203 53.2929 126.899 52.414 125.946C51.9149 125.468 51.4611 124.944 51.0584 124.382C51.6204 124.804 52.1416 125.278 52.6151 125.797C53.5461 126.698 54.8123 127.972 56.1903 129.395H55.9147C57.3224 127.979 58.611 126.713 59.5569 125.812C60.0358 125.285 60.5646 124.806 61.1359 124.382V124.382Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4369 118.863C58.482 120.1 57.4229 121.254 56.2714 122.311L56.1895 122.393L56.0554 122.527L55.9213 122.401C54.7692 121.41 53.7005 120.327 52.726 119.161C53.9598 120.055 55.116 121.051 56.182 122.14H55.9139L55.9958 122.058C57.0552 120.902 58.2059 119.834 59.4369 118.863V118.863Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3437 134.46C68.6413 134.378 67.948 134.231 67.2731 134.02C66.0069 133.7 64.2938 133.231 62.3498 132.687H62.3051L62.1189 132.635L62.171 132.448C62.7445 130.549 63.2883 128.836 63.6607 127.607C63.8652 126.932 64.1346 126.279 64.4651 125.656C64.3673 126.351 64.2078 127.037 63.9884 127.704C63.6458 128.963 63.1467 130.683 62.5732 132.583L62.4391 132.337H62.4838C64.398 132.873 66.1335 133.387 67.3774 133.774C68.0525 133.942 68.7108 134.171 69.3437 134.46V134.46Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3424 130.303C71.8039 130.066 70.287 129.705 68.8064 129.223H68.6947L68.5085 129.171L68.5531 128.992C68.8575 127.504 69.2861 126.044 69.8343 124.628C69.6623 126.14 69.3607 127.636 68.933 129.097L68.7989 128.866H68.9107C70.4253 129.221 71.9077 129.702 73.3424 130.303V130.303Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M64.122 146.615C63.7991 145.986 63.5372 145.328 63.3399 144.649C62.9005 143.42 62.327 141.707 61.7162 139.815V139.77L61.6566 139.584L61.8428 139.524C63.7422 138.951 65.4627 138.444 66.714 138.102C67.3803 137.879 68.0661 137.719 68.7623 137.625C68.129 137.934 67.4682 138.184 66.7885 138.37C65.5595 138.787 63.8539 139.323 61.9546 139.904L62.0812 139.658V139.703C62.6994 141.595 63.2282 143.316 63.5708 144.574C63.8151 145.237 63.9995 145.92 64.122 146.615V146.615Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0534 147.636C68.3953 146.226 67.8571 144.763 67.4446 143.263V143.152L67.3925 142.973L67.5638 142.906C68.9717 142.336 70.4241 141.883 71.9061 141.55C70.5523 142.237 69.1449 142.812 67.6978 143.271L67.817 143.032V143.144C68.3497 144.605 68.7632 146.108 69.0534 147.636V147.636Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M50.969 148.395C51.3657 147.808 51.8171 147.259 52.3171 146.757C53.1811 145.781 54.3952 144.448 55.7583 142.988L55.8923 142.846L56.0338 142.98C57.4565 144.366 58.7301 145.625 59.6388 146.556C60.1574 147.028 60.6289 147.549 61.0466 148.112C60.473 147.707 59.9371 147.251 59.4452 146.749C58.4918 145.87 57.2107 144.641 55.7657 143.263H56.0413C54.6783 144.753 53.4344 146.019 52.5182 146.988C52.0441 147.501 51.5257 147.972 50.969 148.395Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7566 153.214C53.6695 151.953 54.686 150.769 55.7956 149.676L55.8775 149.587L56.0041 149.453L56.1456 149.572C57.3253 150.527 58.4263 151.576 59.4378 152.708C58.1762 151.864 56.9899 150.912 55.8924 149.863H56.1605L56.0786 149.945C55.065 151.126 53.9537 152.22 52.7566 153.214V153.214Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9399 137.647C43.6437 137.736 44.3371 137.893 45.0105 138.117C46.2693 138.452 47.9898 138.943 49.9115 139.51H49.9562L50.1498 139.569L50.0902 139.755C49.4869 141.647 48.9283 143.353 48.5038 144.574C48.3184 145.25 48.069 145.906 47.7589 146.533C47.8604 145.839 48.0275 145.155 48.258 144.492C48.6155 143.249 49.1369 141.513 49.7476 139.636L49.8742 139.882H49.837C47.9228 139.316 46.2022 138.78 44.9584 138.392C44.2633 138.209 43.5873 137.96 42.9399 137.647V137.647Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4463 141.394C40.9816 141.648 42.4936 142.026 43.9674 142.526H44.0791L44.2653 142.578L44.2132 142.757C43.8862 144.252 43.4352 145.717 42.865 147.137C43.0548 145.622 43.3738 144.127 43.8184 142.668L43.9525 142.898H43.8333C42.3321 142.518 40.8648 142.015 39.4463 141.394V141.394Z",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5023 125.32C48.7485 125.985 48.933 126.67 49.0534 127.369C49.3514 128.635 49.7312 130.4 50.126 132.352V132.396L50.1707 132.59L49.977 132.627C48.0256 132.985 46.2529 133.29 44.9718 133.491C44.2857 133.638 43.5875 133.72 42.8862 133.737C43.549 133.502 44.2322 133.33 44.9271 133.223C46.1933 132.955 47.9511 132.605 49.9025 132.247L49.7461 132.471V132.434C49.3514 130.475 49.0013 128.709 48.7853 127.421C48.6265 126.731 48.5317 126.028 48.5023 125.32V125.32Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9821 124.658C43.4829 126.133 43.8592 127.648 44.1068 129.186V129.298V129.484L43.928 129.529C42.4642 129.937 40.9697 130.226 39.459 130.393C40.879 129.856 42.3415 129.44 43.8312 129.149L43.6822 129.38V129.261C43.3236 127.748 43.0894 126.208 42.9821 124.658V124.658Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_112_3",
    x: -6.54144,
    y: -3.27072,
    width: 605.083,
    height: 351.275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.27072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.27072
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_112_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_112_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_112_3",
    x: 124.872,
    y: -126.832,
    width: 341.923,
    height: 342.225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.882,
    result: "effect1_foregroundBlur_112_3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_112_3_clip_path",
    transform: "translate(-241.054 -196.088)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.161,
    y: 217.195,
    width: 147.752,
    height: 125.238,
    rx: 62.6189
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_3",
    x1: 262.161,
    y1: 279.814,
    x2: 409.913,
    y2: 279.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 591.663,
    height: 338,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.42f5a785ac7b1199ee1d8c3ed734ccc1.svg";
export { ForwardRef as ReactComponent };